import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type AcceptInviteResult = {
  __typename?: 'AcceptInviteResult';
  alreadyMember: Scalars['Boolean']['output'];
  organizationId: Scalars['ID']['output'];
  organizationName: Scalars['String']['output'];
};

export type ActiveUserCounts = {
  __typename?: 'ActiveUserCounts';
  daily: Scalars['Int']['output'];
  monthly: Scalars['Int']['output'];
  weekly: Scalars['Int']['output'];
};

export type AddMemberInput = {
  role: OrganizationRole;
  userId: Scalars['ID']['input'];
};

export type AdminScriptDescriptor = {
  __typename?: 'AdminScriptDescriptor';
  dangerous: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  params: Array<AdminScriptParam>;
};

export type AdminScriptDetail = {
  __typename?: 'AdminScriptDetail';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AdminScriptInputArg = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type AdminScriptParam = {
  __typename?: 'AdminScriptParam';
  description?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  type: AdminScriptParamType;
};

export enum AdminScriptParamType {
  String = 'STRING',
  StringList = 'STRING_LIST'
}

export type AdminScriptResult = {
  __typename?: 'AdminScriptResult';
  details: Array<AdminScriptDetail>;
  message: Scalars['String']['output'];
  scriptName: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type AggregatedEdge = {
  __typename?: 'AggregatedEdge';
  source?: Maybe<Node>;
  sourceNode: Scalars['ID']['output'];
  target?: Maybe<Node>;
  targetNode: Scalars['ID']['output'];
  weight: Scalars['Int']['output'];
};

export type AiApiCallItem = {
  __typename?: 'AiApiCallItem';
  completionTokens?: Maybe<Scalars['Int']['output']>;
  costUsd?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  durationMs: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  model: Scalars['String']['output'];
  operation: Scalars['String']['output'];
  organization: AiApiCallOrganization;
  promptTokens?: Maybe<Scalars['Int']['output']>;
  provider: Scalars['String']['output'];
  savaSessionId?: Maybe<Scalars['ID']['output']>;
  totalTokens?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<AiApiCallUser>;
};

export type AiApiCallOrganization = {
  __typename?: 'AiApiCallOrganization';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AiApiCallUser = {
  __typename?: 'AiApiCallUser';
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type AiUsageSummary = {
  __typename?: 'AiUsageSummary';
  avgDurationMs: Scalars['Float']['output'];
  totalCalls: Scalars['Int']['output'];
  totalCompletionTokens: Scalars['Float']['output'];
  totalCostUsd: Scalars['Float']['output'];
  totalPromptTokens: Scalars['Float']['output'];
  totalTokens: Scalars['Float']['output'];
};

export enum BetaAccessStatus {
  Approved = 'APPROVED',
  Waitlist = 'WAITLIST'
}

export type BulkEdgeOperation = {
  action: OperationAction;
  id?: InputMaybe<Scalars['ID']['input']>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  sourceNode?: InputMaybe<Scalars['ID']['input']>;
  targetNode?: InputMaybe<Scalars['ID']['input']>;
  typeName?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type BulkNodeOperation = {
  action: OperationAction;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  typeName?: InputMaybe<Scalars['String']['input']>;
};

export type BulkOperationInput = {
  edges?: InputMaybe<Array<BulkEdgeOperation>>;
  nodes?: InputMaybe<Array<BulkNodeOperation>>;
};

export type BulkOperationResult = {
  __typename?: 'BulkOperationResult';
  edgesCreated: Scalars['Int']['output'];
  edgesDeleted: Scalars['Int']['output'];
  edgesUpdated: Scalars['Int']['output'];
  nodesCreated: Scalars['Int']['output'];
  nodesDeleted: Scalars['Int']['output'];
  nodesUpdated: Scalars['Int']['output'];
};

export type CreateEdgeInput = {
  properties?: InputMaybe<Scalars['JSON']['input']>;
  sourceNode: Scalars['ID']['input'];
  targetNode: Scalars['ID']['input'];
  typeName?: InputMaybe<Scalars['String']['input']>;
  weight: Scalars['Int']['input'];
};

export type CreateManualNoteEventInput = {
  additionalParticipantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  note: Scalars['String']['input'];
  occurredAt?: InputMaybe<Scalars['DateTime']['input']>;
  sourceNodeId: Scalars['ID']['input'];
  targetNodeId: Scalars['ID']['input'];
};

export type CreateManualNoteEventPayload = {
  __typename?: 'CreateManualNoteEventPayload';
  affectedEdges: Array<Edge>;
  event: Event;
};

export type CreateMergedNodeInput = {
  displayName: Scalars['String']['input'];
  typeName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateNodeInput = {
  displayName: Scalars['String']['input'];
  properties?: InputMaybe<Scalars['JSON']['input']>;
  typeName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrganizationInput = {
  name: Scalars['String']['input'];
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  workosId: Scalars['String']['input'];
};

export type CreatePermissionRuleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  level: PermissionLevel;
  name: Scalars['String']['input'];
  priority: Scalars['Int']['input'];
  scope: PermissionScopeInput;
  subjectId?: InputMaybe<Scalars['ID']['input']>;
  subjectKind: PermissionSubjectKind;
};

export type DuplicateGroup = {
  __typename?: 'DuplicateGroup';
  confidence: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  nodes: Array<DuplicateNodeInfo>;
  pairs: Array<DuplicatePair>;
};

export type DuplicateMatchSignal = {
  __typename?: 'DuplicateMatchSignal';
  detail: Scalars['String']['output'];
  score: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type DuplicateNodeInfo = {
  __typename?: 'DuplicateNodeInfo';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  properties?: Maybe<Scalars['JSON']['output']>;
  typeName?: Maybe<Scalars['String']['output']>;
};

export type DuplicatePair = {
  __typename?: 'DuplicatePair';
  nodeA: Scalars['ID']['output'];
  nodeB: Scalars['ID']['output'];
  score: Scalars['Float']['output'];
  signals: Array<DuplicateMatchSignal>;
};

export type Edge = {
  __typename?: 'Edge';
  createdAt: Scalars['DateTime']['output'];
  eventCount: Scalars['Int']['output'];
  events: EventConnection;
  id: Scalars['ID']['output'];
  lastEventAt?: Maybe<Scalars['DateTime']['output']>;
  organizationId: Scalars['ID']['output'];
  primaryNature?: Maybe<Scalars['String']['output']>;
  privateContext?: Maybe<EdgePrivateContext>;
  properties?: Maybe<Scalars['JSON']['output']>;
  publicSummary?: Maybe<Scalars['String']['output']>;
  publicSummaryGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  source?: Maybe<Node>;
  sourceNode: Scalars['ID']['output'];
  strength?: Maybe<Scalars['Float']['output']>;
  target?: Maybe<Node>;
  targetNode: Scalars['ID']['output'];
  topOfMindEvents: Array<Event>;
  typeName?: Maybe<Scalars['String']['output']>;
  typedProperties?: Maybe<Array<EdgeProperty>>;
  updatedAt: Scalars['DateTime']['output'];
  weight: Scalars['Int']['output'];
};


export type EdgeEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type EdgeConnection = {
  __typename?: 'EdgeConnection';
  edges: Array<EdgeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EdgeEdge = {
  __typename?: 'EdgeEdge';
  cursor: Scalars['String']['output'];
  node: Edge;
};

export type EdgeFilter = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  sourceNodes?: InputMaybe<Array<Scalars['ID']['input']>>;
  targetNodes?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type EdgePrivateContext = {
  __typename?: 'EdgePrivateContext';
  generatedAt?: Maybe<Scalars['DateTime']['output']>;
  privateSummary?: Maybe<Scalars['String']['output']>;
  topOfMindEvents: Array<Event>;
};

export type EdgeProperty = {
  __typename?: 'EdgeProperty';
  access: PermissionLevel;
  createdAt: Scalars['DateTime']['output'];
  edgeId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  type: PropertyType;
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['JSON']['output']>;
};

export enum EdgeWeightStrategy {
  Average = 'AVERAGE',
  Max = 'MAX',
  Min = 'MIN'
}

export type EffectiveAccess = {
  __typename?: 'EffectiveAccess';
  edges: Array<EffectiveEdgeAccess>;
  level: PermissionLevel;
  nodeId: Scalars['ID']['output'];
  properties: Array<EffectivePropertyAccess>;
};

export type EffectiveEdgeAccess = {
  __typename?: 'EffectiveEdgeAccess';
  access: PermissionLevel;
  edgeId: Scalars['ID']['output'];
  properties: Array<EffectivePropertyAccess>;
};

export type EffectivePropertyAccess = {
  __typename?: 'EffectivePropertyAccess';
  access: PermissionLevel;
  key: Scalars['String']['output'];
};

export type EmployeeAiUsageFilter = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  operation?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeeAiUsageResult = {
  __typename?: 'EmployeeAiUsageResult';
  items: Array<AiApiCallItem>;
  summary: AiUsageSummary;
  totalCount: Scalars['Int']['output'];
};

export type EmployeeOrganizationMember = {
  __typename?: 'EmployeeOrganizationMember';
  createdAt: Scalars['DateTime']['output'];
  lastActiveAt?: Maybe<Scalars['DateTime']['output']>;
  role: Scalars['String']['output'];
  user: EmployeeUserSummary;
};

export type EmployeeOrganizationSummary = {
  __typename?: 'EmployeeOrganizationSummary';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type EmployeeOrganizationView = {
  __typename?: 'EmployeeOrganizationView';
  aiCostUsd: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  members: Array<EmployeeOrganizationMember>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  websiteUrl?: Maybe<Scalars['String']['output']>;
  workosId: Scalars['String']['output'];
};

export type EmployeeOrganizationsResult = {
  __typename?: 'EmployeeOrganizationsResult';
  organizations: Array<EmployeeOrganizationView>;
  totalCount: Scalars['Int']['output'];
};

export type EmployeeUserActivityResult = {
  __typename?: 'EmployeeUserActivityResult';
  totalCount: Scalars['Int']['output'];
  users: Array<UserActivitySummary>;
};

export type EmployeeUserMembership = {
  __typename?: 'EmployeeUserMembership';
  createdAt: Scalars['DateTime']['output'];
  organization: EmployeeOrganizationSummary;
  role: Scalars['String']['output'];
};

export type EmployeeUserSummary = {
  __typename?: 'EmployeeUserSummary';
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type EmployeeUserView = {
  __typename?: 'EmployeeUserView';
  activeDatesLast30Days: Array<Scalars['DateTime']['output']>;
  aiCostUsd: Scalars['Float']['output'];
  betaAccessStatus: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isEmployee: Scalars['Boolean']['output'];
  lastActiveAt?: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  memberships: Array<EmployeeUserMembership>;
  phone?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type EmployeeUsersResult = {
  __typename?: 'EmployeeUsersResult';
  totalCount: Scalars['Int']['output'];
  users: Array<EmployeeUserView>;
};

export type Event = {
  __typename?: 'Event';
  createdAt: Scalars['DateTime']['output'];
  eventType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  occurredAt?: Maybe<Scalars['DateTime']['output']>;
  organizationId: Scalars['ID']['output'];
  participations: Array<EventParticipation>;
  payload?: Maybe<Scalars['JSON']['output']>;
  source: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type EventConnection = {
  __typename?: 'EventConnection';
  edges: Array<EventEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventEdge = {
  __typename?: 'EventEdge';
  cursor: Scalars['String']['output'];
  node: Event;
};

export type EventParticipation = {
  __typename?: 'EventParticipation';
  node: Node;
  role: Scalars['String']['output'];
};

export type FindDuplicatesResult = {
  __typename?: 'FindDuplicatesResult';
  analyzedNodeCount: Scalars['Int']['output'];
  groups: Array<DuplicateGroup>;
  totalGroupsFound: Scalars['Int']['output'];
};

export type GraphData = {
  __typename?: 'GraphData';
  edges: Array<Edge>;
  nodes: Array<Node>;
};

export type InviteMembersInput = {
  emails: Array<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  role: OrganizationRole;
};

export type InviteResult = {
  __typename?: 'InviteResult';
  email: Scalars['String']['output'];
  invite?: Maybe<OrganizationInvite>;
  status: InviteResultStatus;
};

export enum InviteResultStatus {
  AlreadyInvited = 'ALREADY_INVITED',
  AlreadyMember = 'ALREADY_MEMBER',
  EmailFailed = 'EMAIL_FAILED',
  Invited = 'INVITED'
}

export enum InviteStatus {
  Accepted = 'ACCEPTED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Revoked = 'REVOKED'
}

export type MergeNodesInput = {
  edgeWeightStrategy: EdgeWeightStrategy;
  manualProperties?: InputMaybe<Scalars['JSON']['input']>;
  newNodeData?: InputMaybe<CreateMergedNodeInput>;
  nodeIds: Array<Scalars['ID']['input']>;
  preserveEdgeTypes?: InputMaybe<Scalars['Boolean']['input']>;
  propertyStrategy: PropertyConflictStrategy;
  survivingNodeId?: InputMaybe<Scalars['ID']['input']>;
};

export type MergeNodesResult = {
  __typename?: 'MergeNodesResult';
  consolidatedEdgeCount: Scalars['Int']['output'];
  deletedEdgeCount: Scalars['Int']['output'];
  mergedNodeIds: Array<Scalars['ID']['output']>;
  redirectedEdgeCount: Scalars['Int']['output'];
  survivingNode: Node;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptInvite: AcceptInviteResult;
  addMember: Scalars['String']['output'];
  addTeamMember: Scalars['Boolean']['output'];
  approveWaitlistUser: User;
  assignRole: Scalars['Boolean']['output'];
  bulkGraphOperations: BulkOperationResult;
  createEdges: Array<Edge>;
  createManualNoteEvent: CreateManualNoteEventPayload;
  createNodes: Array<Node>;
  createOrganization: Organization;
  createPermissionRule: PermissionRule;
  createRole: Role;
  createTeam: Team;
  deleteEdges: Array<Scalars['ID']['output']>;
  deleteNodes: Array<Scalars['ID']['output']>;
  deleteOrganization: Organization;
  deletePermissionRule: Scalars['ID']['output'];
  deleteSavaSession: Scalars['Boolean']['output'];
  deleteUser?: Maybe<User>;
  employeeDeleteOrganization: Scalars['Boolean']['output'];
  employeeDeleteUser: Scalars['Boolean']['output'];
  employeeSetUserEmployee: EmployeeUserView;
  inviteMembersByEmail: Array<InviteResult>;
  leaveOrganization: Scalars['String']['output'];
  mergeNodes: MergeNodesResult;
  parseTextToGraph: ParsedGraphData;
  refreshEdgeSummary?: Maybe<Edge>;
  removeMember: Scalars['String']['output'];
  removeTeamMember: Scalars['Boolean']['output'];
  resendInvite: OrganizationInvite;
  revokeInvite: Scalars['String']['output'];
  runAdminScript: AdminScriptResult;
  updateEdge?: Maybe<Edge>;
  updateMemberRole: Scalars['String']['output'];
  updateNode?: Maybe<Node>;
  updateOrganization: Organization;
  updatePermissionRule: PermissionRule;
  updateUser?: Maybe<User>;
  updateUserNode: UserOrganization;
};


export type MutationAcceptInviteArgs = {
  inviteCode: Scalars['ID']['input'];
};


export type MutationAddMemberArgs = {
  input: AddMemberInput;
  organizationId: Scalars['ID']['input'];
};


export type MutationAddTeamMemberArgs = {
  organizationId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationApproveWaitlistUserArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationAssignRoleArgs = {
  organizationId: Scalars['ID']['input'];
  roleId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationBulkGraphOperationsArgs = {
  operations: BulkOperationInput;
  organizationId: Scalars['ID']['input'];
};


export type MutationCreateEdgesArgs = {
  inputs: Array<CreateEdgeInput>;
  organizationId: Scalars['ID']['input'];
};


export type MutationCreateManualNoteEventArgs = {
  input: CreateManualNoteEventInput;
  organizationId: Scalars['ID']['input'];
};


export type MutationCreateNodesArgs = {
  inputs: Array<CreateNodeInput>;
  organizationId: Scalars['ID']['input'];
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationCreatePermissionRuleArgs = {
  input: CreatePermissionRuleInput;
  organizationId: Scalars['ID']['input'];
};


export type MutationCreateRoleArgs = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationCreateTeamArgs = {
  color?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationDeleteEdgesArgs = {
  ids: Array<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type MutationDeleteNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type MutationDeleteOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePermissionRuleArgs = {
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationDeleteSavaSessionArgs = {
  organizationId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEmployeeDeleteOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationEmployeeDeleteUserArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationEmployeeSetUserEmployeeArgs = {
  isEmployee: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationInviteMembersByEmailArgs = {
  input: InviteMembersInput;
};


export type MutationLeaveOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationMergeNodesArgs = {
  input: MergeNodesInput;
  organizationId: Scalars['ID']['input'];
};


export type MutationParseTextToGraphArgs = {
  modelId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRefreshEdgeSummaryArgs = {
  edgeId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationRemoveMemberArgs = {
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationRemoveTeamMemberArgs = {
  organizationId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationResendInviteArgs = {
  inviteCode: Scalars['ID']['input'];
};


export type MutationRevokeInviteArgs = {
  inviteCode: Scalars['ID']['input'];
};


export type MutationRunAdminScriptArgs = {
  input?: InputMaybe<Array<AdminScriptInputArg>>;
  name: Scalars['String']['input'];
};


export type MutationUpdateEdgeArgs = {
  id: Scalars['ID']['input'];
  input: UpdateEdgeInput;
  organizationId: Scalars['ID']['input'];
};


export type MutationUpdateMemberRoleArgs = {
  organizationId: Scalars['ID']['input'];
  role: OrganizationRole;
  userId: Scalars['ID']['input'];
};


export type MutationUpdateNodeArgs = {
  id: Scalars['ID']['input'];
  input: UpdateNodeInput;
  organizationId: Scalars['ID']['input'];
};


export type MutationUpdateOrganizationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateOrganizationInput;
};


export type MutationUpdatePermissionRuleArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePermissionRuleInput;
  organizationId: Scalars['ID']['input'];
};


export type MutationUpdateUserArgs = {
  id: Scalars['ID']['input'];
  input: UpdateUserInput;
};


export type MutationUpdateUserNodeArgs = {
  nodeId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type Node = {
  __typename?: 'Node';
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  edges: Array<Edge>;
  hasImage: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  properties?: Maybe<Scalars['JSON']['output']>;
  typeName?: Maybe<Scalars['String']['output']>;
  typedProperties?: Maybe<Array<NodeProperty>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type NodeConnection = {
  __typename?: 'NodeConnection';
  edges: Array<NodeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NodeEdge = {
  __typename?: 'NodeEdge';
  cursor: Scalars['String']['output'];
  node: Node;
};

export type NodeFilter = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  typeName?: InputMaybe<Scalars['String']['input']>;
};

export type NodeProperty = {
  __typename?: 'NodeProperty';
  access: PermissionLevel;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  nodeId: Scalars['ID']['output'];
  type: PropertyType;
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['JSON']['output']>;
};

export enum OperationAction {
  Create = 'CREATE',
  Delete = 'DELETE',
  Update = 'UPDATE'
}

export type Organization = {
  __typename?: 'Organization';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  members: Array<OrganizationMember>;
  name: Scalars['String']['output'];
  nodeId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  websiteUrl?: Maybe<Scalars['String']['output']>;
  workosId: Scalars['String']['output'];
};

export type OrganizationInvite = {
  __typename?: 'OrganizationInvite';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  createdByUser: User;
  email: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  inviteCode: Scalars['ID']['output'];
  isExpired: Scalars['Boolean']['output'];
  lastSentAt?: Maybe<Scalars['DateTime']['output']>;
  organization: Organization;
  role: OrganizationRole;
  status: InviteStatus;
  updatedAt: Scalars['DateTime']['output'];
  usedAt?: Maybe<Scalars['DateTime']['output']>;
  usedBy?: Maybe<Scalars['ID']['output']>;
  usedByUser?: Maybe<User>;
};

export type OrganizationMember = {
  __typename?: 'OrganizationMember';
  nodeId?: Maybe<Scalars['ID']['output']>;
  role: OrganizationRole;
  user: User;
};

export enum OrganizationRole {
  Admin = 'ADMIN',
  Member = 'MEMBER'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type ParsedEdge = {
  __typename?: 'ParsedEdge';
  properties?: Maybe<Scalars['JSON']['output']>;
  sourceNode: Scalars['String']['output'];
  targetNode: Scalars['String']['output'];
  typeName: Scalars['String']['output'];
  weight: Scalars['Int']['output'];
};

export type ParsedEvent = {
  __typename?: 'ParsedEvent';
  eventType: Scalars['String']['output'];
  occurredAt?: Maybe<Scalars['String']['output']>;
  participants: Array<Scalars['String']['output']>;
  properties?: Maybe<Scalars['JSON']['output']>;
};

export type ParsedGraphData = {
  __typename?: 'ParsedGraphData';
  edges: Array<ParsedEdge>;
  events: Array<ParsedEvent>;
  nodes: Array<ParsedNode>;
};

export type ParsedNode = {
  __typename?: 'ParsedNode';
  displayName: Scalars['String']['output'];
  properties?: Maybe<Scalars['JSON']['output']>;
  typeName: Scalars['String']['output'];
};

export type Path = {
  __typename?: 'Path';
  edges: Array<Edge>;
  nodes: Array<Node>;
  totalWeight: Scalars['Int']['output'];
};

export enum PermissionLevel {
  Edit = 'EDIT',
  Full = 'FULL',
  None = 'NONE',
  Read = 'READ'
}

export type PermissionRule = {
  __typename?: 'PermissionRule';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  level: PermissionLevel;
  locked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  priority: Scalars['Int']['output'];
  scope: PermissionScope;
  source: PermissionSource;
  subjectId?: Maybe<Scalars['ID']['output']>;
  subjectKind: PermissionSubjectKind;
  updatedAt: Scalars['DateTime']['output'];
};

export type PermissionScope = {
  __typename?: 'PermissionScope';
  edgeId?: Maybe<Scalars['ID']['output']>;
  kind: PermissionScopeKind;
  name?: Maybe<Scalars['String']['output']>;
  nodeId?: Maybe<Scalars['ID']['output']>;
  nodeType?: Maybe<Scalars['String']['output']>;
  predicate?: Maybe<Scalars['JSON']['output']>;
  propId?: Maybe<Scalars['String']['output']>;
  propName?: Maybe<Scalars['String']['output']>;
  relType?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
};

export type PermissionScopeInput = {
  edgeId?: InputMaybe<Scalars['ID']['input']>;
  kind: PermissionScopeKind;
  name?: InputMaybe<Scalars['String']['input']>;
  nodeId?: InputMaybe<Scalars['ID']['input']>;
  nodeType?: InputMaybe<Scalars['String']['input']>;
  predicate?: InputMaybe<Scalars['JSON']['input']>;
  propId?: InputMaybe<Scalars['String']['input']>;
  propName?: InputMaybe<Scalars['String']['input']>;
  relType?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
};

export enum PermissionScopeKind {
  ByRelType = 'BY_REL_TYPE',
  ByTag = 'BY_TAG',
  ByType = 'BY_TYPE',
  Edge = 'EDGE',
  EdgeProp = 'EDGE_PROP',
  EdgePropByRelType = 'EDGE_PROP_BY_REL_TYPE',
  Global = 'GLOBAL',
  Node = 'NODE',
  Property = 'PROPERTY',
  PropertyName = 'PROPERTY_NAME',
  Query = 'QUERY'
}

export enum PermissionSource {
  Default = 'DEFAULT',
  System = 'SYSTEM',
  User = 'USER'
}

export enum PermissionSubjectKind {
  Everyone = 'EVERYONE',
  Role = 'ROLE',
  Team = 'TEAM',
  User = 'USER'
}

export type PermissionSubjectTeam = {
  __typename?: 'PermissionSubjectTeam';
  color?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  memberIds: Array<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
};

export type PermissionSubjectUser = {
  __typename?: 'PermissionSubjectUser';
  id: Scalars['ID']['output'];
  isAdmin: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  roleId?: Maybe<Scalars['ID']['output']>;
  teamIds: Array<Scalars['ID']['output']>;
};

export type PermissionSubjects = {
  __typename?: 'PermissionSubjects';
  roles: Array<Role>;
  teams: Array<PermissionSubjectTeam>;
  users: Array<PermissionSubjectUser>;
};

export type PreviewSubjectInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  kind: PermissionSubjectKind;
};

export enum PropertyConflictStrategy {
  ArrayMerge = 'ARRAY_MERGE',
  FirstWins = 'FIRST_WINS',
  LastWins = 'LAST_WINS',
  Manual = 'MANUAL',
  SurvivingWins = 'SURVIVING_WINS'
}

export enum PropertyType {
  Address = 'ADDRESS',
  Array = 'ARRAY',
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Email = 'EMAIL',
  Number = 'NUMBER',
  Object = 'OBJECT',
  Phone = 'PHONE',
  Text = 'TEXT',
  Url = 'URL'
}

export type Query = {
  __typename?: 'Query';
  adminScripts: Array<AdminScriptDescriptor>;
  aggregatedEdges: Array<AggregatedEdge>;
  currentUser?: Maybe<User>;
  distinctEdgeTypeNames: Array<Scalars['String']['output']>;
  distinctNodeTypeNames: Array<Scalars['String']['output']>;
  edge?: Maybe<Edge>;
  edges: EdgeConnection;
  effectiveNodeAccess?: Maybe<EffectiveAccess>;
  employeeActiveUserCounts: ActiveUserCounts;
  employeeAiUsage: EmployeeAiUsageResult;
  employeeOrganization?: Maybe<EmployeeOrganizationView>;
  employeeOrganizations: EmployeeOrganizationsResult;
  employeeUser?: Maybe<EmployeeUserView>;
  employeeUserActivity: EmployeeUserActivityResult;
  employeeUsers: EmployeeUsersResult;
  events: Array<Event>;
  findDuplicates: FindDuplicatesResult;
  findPath?: Maybe<Path>;
  invitePreview?: Maybe<OrganizationInvite>;
  node?: Maybe<Node>;
  nodes: NodeConnection;
  organization?: Maybe<Organization>;
  organizationInvites: Array<OrganizationInvite>;
  organizations: Array<UserOrganization>;
  permissionRules: Array<PermissionRule>;
  permissionSubjects: PermissionSubjects;
  roles: Array<Role>;
  savaSession?: Maybe<SavaSessionWithMessages>;
  savaSessions: Array<SavaSession>;
  searchGraph: GraphData;
  syncChanges: SyncChangesResult;
  teams: Array<Team>;
  user?: Maybe<User>;
  users: Array<User>;
  waitlistUsers: Array<User>;
};


export type QueryAggregatedEdgesArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryDistinctEdgeTypeNamesArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryDistinctNodeTypeNamesArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryEdgeArgs = {
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type QueryEdgesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<EdgeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type QueryEffectiveNodeAccessArgs = {
  nodeId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  subject?: InputMaybe<PreviewSubjectInput>;
};


export type QueryEmployeeActiveUserCountsArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryEmployeeAiUsageArgs = {
  filter?: InputMaybe<EmployeeAiUsageFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEmployeeOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmployeeOrganizationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEmployeeUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmployeeUserActivityArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UserActivityOrderBy>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEmployeeUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEventsArgs = {
  ids: Array<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type QueryFindDuplicatesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  minConfidence?: InputMaybe<Scalars['Float']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type QueryFindPathArgs = {
  organizationId: Scalars['ID']['input'];
  sourceNodeId: Scalars['ID']['input'];
  targetNodeId: Scalars['ID']['input'];
};


export type QueryInvitePreviewArgs = {
  inviteCode: Scalars['ID']['input'];
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type QueryNodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<NodeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type QueryOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganizationInvitesArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryPermissionRulesArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryPermissionSubjectsArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryRolesArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QuerySavaSessionArgs = {
  organizationId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
};


export type QuerySavaSessionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type QuerySearchGraphArgs = {
  organizationId: Scalars['ID']['input'];
  search: SearchInput;
};


export type QuerySyncChangesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type QueryTeamsArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};

export type Role = {
  __typename?: 'Role';
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isSystem: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SavaMessage = {
  __typename?: 'SavaMessage';
  actionsTaken?: Maybe<Array<Scalars['String']['output']>>;
  confidence?: Maybe<Scalars['Float']['output']>;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  role: Scalars['String']['output'];
  suggestions?: Maybe<Array<Scalars['String']['output']>>;
  toolsUsed?: Maybe<Array<Scalars['String']['output']>>;
};

export type SavaSession = {
  __typename?: 'SavaSession';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  messageCount: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SavaSessionWithMessages = {
  __typename?: 'SavaSessionWithMessages';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  messages: Array<SavaMessage>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SearchInput = {
  edgeFilter?: InputMaybe<EdgeFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nodeFilter?: InputMaybe<NodeFilter>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type SyncChangesResult = {
  __typename?: 'SyncChangesResult';
  cursor: Scalars['String']['output'];
  edges: Array<SyncEdgeChange>;
  events: Array<SyncEventChange>;
  hasMore: Scalars['Boolean']['output'];
  nodes: Array<SyncNodeChange>;
};

export type SyncEdgeChange = {
  __typename?: 'SyncEdgeChange';
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  properties?: Maybe<Scalars['JSON']['output']>;
  sourceNode: Scalars['ID']['output'];
  targetNode: Scalars['ID']['output'];
  typeName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  weight?: Maybe<Scalars['Int']['output']>;
};

export type SyncEventChange = {
  __typename?: 'SyncEventChange';
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  eventType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  occurredAt?: Maybe<Scalars['DateTime']['output']>;
  participations: Array<SyncEventParticipation>;
  payload?: Maybe<Scalars['JSON']['output']>;
  source: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SyncEventParticipation = {
  __typename?: 'SyncEventParticipation';
  nodeId: Scalars['ID']['output'];
  role: Scalars['String']['output'];
};

export type SyncNodeChange = {
  __typename?: 'SyncNodeChange';
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  properties?: Maybe<Scalars['JSON']['output']>;
  typeName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type Team = {
  __typename?: 'Team';
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type UpdateEdgeInput = {
  properties?: InputMaybe<Scalars['JSON']['input']>;
  typeName?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateNodeInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  typeName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePermissionRuleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<PermissionLevel>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<PermissionScopeInput>;
  subjectId?: InputMaybe<Scalars['ID']['input']>;
  subjectKind?: InputMaybe<PermissionSubjectKind>;
};

export type UpdateUserInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  betaAccessStatus: BetaAccessStatus;
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isEmployee: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum UserActivityOrderBy {
  ActiveDays = 'ACTIVE_DAYS',
  DisplayName = 'DISPLAY_NAME',
  LastActiveAt = 'LAST_ACTIVE_AT'
}

export type UserActivitySummary = {
  __typename?: 'UserActivitySummary';
  activeDates: Array<Scalars['DateTime']['output']>;
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  lastActiveAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['ID']['output'];
};

export type UserOrganization = {
  __typename?: 'UserOrganization';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nodeId?: Maybe<Scalars['ID']['output']>;
  role: OrganizationRole;
  updatedAt: Scalars['DateTime']['output'];
  websiteUrl?: Maybe<Scalars['String']['output']>;
  workosId: Scalars['String']['output'];
};

export type GetCurrentUserAndOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserAndOrganizationsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, firstName: string, lastName: string, displayName: string, email: string, phone?: string | null, betaAccessStatus: BetaAccessStatus, isEmployee: boolean, createdAt: any, updatedAt: any } | null, organizations: Array<{ __typename?: 'UserOrganization', id: string, name: string, websiteUrl?: string | null, role: OrganizationRole, nodeId?: string | null }> };

export type GetWaitlistUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWaitlistUsersQuery = { __typename?: 'Query', waitlistUsers: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string, displayName: string, email: string, createdAt: any }> };

export type ApproveWaitlistUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type ApproveWaitlistUserMutation = { __typename?: 'Mutation', approveWaitlistUser: { __typename?: 'User', id: string, email: string, betaAccessStatus: BetaAccessStatus } };

export type EmployeeGetUsersQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EmployeeGetUsersQuery = { __typename?: 'Query', employeeUsers: { __typename?: 'EmployeeUsersResult', totalCount: number, users: Array<{ __typename?: 'EmployeeUserView', id: string, firstName: string, lastName: string, displayName: string, email: string, phone?: string | null, betaAccessStatus: string, isEmployee: boolean, createdAt: any, updatedAt: any, memberships: Array<{ __typename?: 'EmployeeUserMembership', role: string, createdAt: any, organization: { __typename?: 'EmployeeOrganizationSummary', id: string, name: string } }> }> } };

export type EmployeeGetUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EmployeeGetUserQuery = { __typename?: 'Query', employeeUser?: { __typename?: 'EmployeeUserView', id: string, firstName: string, lastName: string, displayName: string, email: string, phone?: string | null, betaAccessStatus: string, isEmployee: boolean, createdAt: any, updatedAt: any, aiCostUsd: number, lastActiveAt?: any | null, activeDatesLast30Days: Array<any>, memberships: Array<{ __typename?: 'EmployeeUserMembership', role: string, createdAt: any, organization: { __typename?: 'EmployeeOrganizationSummary', id: string, name: string } }> } | null };

export type EmployeeGetOrganizationsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EmployeeGetOrganizationsQuery = { __typename?: 'Query', employeeOrganizations: { __typename?: 'EmployeeOrganizationsResult', totalCount: number, organizations: Array<{ __typename?: 'EmployeeOrganizationView', id: string, name: string, websiteUrl?: string | null, workosId: string, createdAt: any, updatedAt: any, members: Array<{ __typename?: 'EmployeeOrganizationMember', role: string, createdAt: any, user: { __typename?: 'EmployeeUserSummary', id: string, displayName: string, email: string } }> }> } };

export type EmployeeGetOrganizationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EmployeeGetOrganizationQuery = { __typename?: 'Query', employeeOrganization?: { __typename?: 'EmployeeOrganizationView', id: string, name: string, websiteUrl?: string | null, workosId: string, createdAt: any, updatedAt: any, aiCostUsd: number, members: Array<{ __typename?: 'EmployeeOrganizationMember', role: string, createdAt: any, lastActiveAt?: any | null, user: { __typename?: 'EmployeeUserSummary', id: string, displayName: string, email: string } }> } | null };

export type EmployeeSetUserEmployeeMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  isEmployee: Scalars['Boolean']['input'];
}>;


export type EmployeeSetUserEmployeeMutation = { __typename?: 'Mutation', employeeSetUserEmployee: { __typename?: 'EmployeeUserView', id: string, isEmployee: boolean } };

export type EmployeeDeleteUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type EmployeeDeleteUserMutation = { __typename?: 'Mutation', employeeDeleteUser: boolean };

export type EmployeeDeleteOrganizationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type EmployeeDeleteOrganizationMutation = { __typename?: 'Mutation', employeeDeleteOrganization: boolean };

export type GetAdminScriptsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdminScriptsQuery = { __typename?: 'Query', adminScripts: Array<{ __typename?: 'AdminScriptDescriptor', name: string, displayName: string, description: string, dangerous: boolean, params: Array<{ __typename?: 'AdminScriptParam', key: string, label: string, description?: string | null, type: AdminScriptParamType, required: boolean }> }> };

export type RunAdminScriptMutationVariables = Exact<{
  name: Scalars['String']['input'];
  input?: InputMaybe<Array<AdminScriptInputArg> | AdminScriptInputArg>;
}>;


export type RunAdminScriptMutation = { __typename?: 'Mutation', runAdminScript: { __typename?: 'AdminScriptResult', scriptName: string, success: boolean, message: string, details: Array<{ __typename?: 'AdminScriptDetail', key: string, value: string }> } };

export type EmployeeGetActiveUserCountsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type EmployeeGetActiveUserCountsQuery = { __typename?: 'Query', employeeActiveUserCounts: { __typename?: 'ActiveUserCounts', daily: number, weekly: number, monthly: number } };

export type EmployeeGetUserActivityQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  days?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UserActivityOrderBy>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EmployeeGetUserActivityQuery = { __typename?: 'Query', employeeUserActivity: { __typename?: 'EmployeeUserActivityResult', totalCount: number, users: Array<{ __typename?: 'UserActivitySummary', userId: string, displayName: string, email: string, activeDates: Array<any>, lastActiveAt?: any | null }> } };

export type EmployeeGetAiUsageQueryVariables = Exact<{
  filter?: InputMaybe<EmployeeAiUsageFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EmployeeGetAiUsageQuery = { __typename?: 'Query', employeeAiUsage: { __typename?: 'EmployeeAiUsageResult', totalCount: number, items: Array<{ __typename?: 'AiApiCallItem', id: string, model: string, operation: string, promptTokens?: number | null, completionTokens?: number | null, totalTokens?: number | null, durationMs: number, costUsd?: number | null, createdAt: any, user?: { __typename?: 'AiApiCallUser', id: string, displayName: string, email: string } | null, organization: { __typename?: 'AiApiCallOrganization', id: string, name: string } }>, summary: { __typename?: 'AiUsageSummary', totalCalls: number, totalPromptTokens: number, totalCompletionTokens: number, totalTokens: number, totalCostUsd: number, avgDurationMs: number } } };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'User', id: string, firstName: string, lastName: string, displayName: string, email: string, phone?: string | null, createdAt: any, updatedAt: any } | null };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser?: { __typename?: 'User', id: string, email: string } | null };

export type UpdateOrganizationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateOrganizationInput;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'Organization', id: string, name: string, websiteUrl?: string | null, createdAt: any, updatedAt: any } };

export type UpdateUserNodeMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  nodeId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateUserNodeMutation = { __typename?: 'Mutation', updateUserNode: { __typename?: 'UserOrganization', id: string, name: string, role: OrganizationRole, nodeId?: string | null } };

export type GetDistinctNodeTypeNamesQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type GetDistinctNodeTypeNamesQuery = { __typename?: 'Query', distinctNodeTypeNames: Array<string> };

export type GetNodesListQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<NodeFilter>;
}>;


export type GetNodesListQuery = { __typename?: 'Query', nodes: { __typename?: 'NodeConnection', totalCount: number, edges: Array<{ __typename?: 'NodeEdge', node: { __typename?: 'Node', id: string, displayName: string, typeName?: string | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type GetNodeQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  nodeId: Scalars['ID']['input'];
}>;


export type GetNodeQuery = { __typename?: 'Query', node?: { __typename?: 'Node', id: string, displayName: string, typeName?: string | null, hasImage: boolean, organizationId: string } | null };

export type GetNodesForVcfQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  first: Scalars['Int']['input'];
}>;


export type GetNodesForVcfQuery = { __typename?: 'Query', nodes: { __typename?: 'NodeConnection', edges: Array<{ __typename?: 'NodeEdge', node: { __typename?: 'Node', id: string, displayName: string, typedProperties?: Array<{ __typename?: 'NodeProperty', key: string, value?: any | null, type: PropertyType }> | null } }> } };

export type AddMemberMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  input: AddMemberInput;
}>;


export type AddMemberMutation = { __typename?: 'Mutation', addMember: string };

export type RemoveMemberMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type RemoveMemberMutation = { __typename?: 'Mutation', removeMember: string };

export type UpdateMemberRoleMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  role: OrganizationRole;
}>;


export type UpdateMemberRoleMutation = { __typename?: 'Mutation', updateMemberRole: string };

export type CreateOrganizationMutationVariables = Exact<{
  input: CreateOrganizationInput;
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', createOrganization: { __typename?: 'Organization', id: string, name: string, websiteUrl?: string | null, workosId: string, createdAt: any, updatedAt: any } };

export type DeleteOrganizationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteOrganizationMutation = { __typename?: 'Mutation', deleteOrganization: { __typename?: 'Organization', id: string, name: string } };

export type LeaveOrganizationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type LeaveOrganizationMutation = { __typename?: 'Mutation', leaveOrganization: string };

export type InviteMembersByEmailMutationVariables = Exact<{
  input: InviteMembersInput;
}>;


export type InviteMembersByEmailMutation = { __typename?: 'Mutation', inviteMembersByEmail: Array<{ __typename?: 'InviteResult', email: string, status: InviteResultStatus, invite?: { __typename?: 'OrganizationInvite', inviteCode: string, email: string, role: OrganizationRole, status: InviteStatus, isExpired: boolean, expiresAt?: any | null, createdAt: any, createdByUser: { __typename?: 'User', id: string, displayName: string } } | null }> };

export type AcceptInviteMutationVariables = Exact<{
  inviteCode: Scalars['ID']['input'];
}>;


export type AcceptInviteMutation = { __typename?: 'Mutation', acceptInvite: { __typename?: 'AcceptInviteResult', organizationId: string, organizationName: string, alreadyMember: boolean } };

export type RevokeInviteMutationVariables = Exact<{
  inviteCode: Scalars['ID']['input'];
}>;


export type RevokeInviteMutation = { __typename?: 'Mutation', revokeInvite: string };

export type ResendInviteMutationVariables = Exact<{
  inviteCode: Scalars['ID']['input'];
}>;


export type ResendInviteMutation = { __typename?: 'Mutation', resendInvite: { __typename?: 'OrganizationInvite', inviteCode: string, status: InviteStatus, isExpired: boolean, expiresAt?: any | null, lastSentAt?: any | null } };

export type GetOrganizationInvitesQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type GetOrganizationInvitesQuery = { __typename?: 'Query', organizationInvites: Array<{ __typename?: 'OrganizationInvite', inviteCode: string, email: string, role: OrganizationRole, status: InviteStatus, isExpired: boolean, expiresAt?: any | null, lastSentAt?: any | null, createdAt: any, usedAt?: any | null, createdByUser: { __typename?: 'User', id: string, displayName: string }, usedByUser?: { __typename?: 'User', id: string, displayName: string, email: string } | null }> };

export type InvitePreviewQueryVariables = Exact<{
  inviteCode: Scalars['ID']['input'];
}>;


export type InvitePreviewQuery = { __typename?: 'Query', invitePreview?: { __typename?: 'OrganizationInvite', inviteCode: string, email: string, role: OrganizationRole, status: InviteStatus, isExpired: boolean, expiresAt?: any | null, organization: { __typename?: 'Organization', id: string, name: string }, createdByUser: { __typename?: 'User', id: string, displayName: string } } | null };

export type GetOrganizationMembersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOrganizationMembersQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, name: string, websiteUrl?: string | null, workosId: string, createdAt: any, updatedAt: any, members: Array<{ __typename?: 'OrganizationMember', role: OrganizationRole, user: { __typename?: 'User', id: string, displayName: string, email: string, firstName: string, lastName: string } }> } | null };

export type MergeNodesMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  input: MergeNodesInput;
}>;


export type MergeNodesMutation = { __typename?: 'Mutation', mergeNodes: { __typename?: 'MergeNodesResult', mergedNodeIds: Array<string>, redirectedEdgeCount: number, consolidatedEdgeCount: number, deletedEdgeCount: number, survivingNode: { __typename?: 'Node', id: string, displayName: string, typeName?: string | null } } };

export type GetSavaSessionsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type GetSavaSessionsQuery = { __typename?: 'Query', savaSessions: Array<{ __typename?: 'SavaSession', id: string, title: string, messageCount: number, createdAt: any, updatedAt: any }> };

export type GetSavaSessionQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
}>;


export type GetSavaSessionQuery = { __typename?: 'Query', savaSession?: { __typename?: 'SavaSessionWithMessages', id: string, title: string, createdAt: any, updatedAt: any, messages: Array<{ __typename?: 'SavaMessage', id: string, role: string, content: string, suggestions?: Array<string> | null, confidence?: number | null, toolsUsed?: Array<string> | null, createdAt: any }> } | null };

export type DeleteSavaSessionMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
}>;


export type DeleteSavaSessionMutation = { __typename?: 'Mutation', deleteSavaSession: boolean };

export type FindDuplicatesQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  minConfidence?: InputMaybe<Scalars['Float']['input']>;
}>;


export type FindDuplicatesQuery = { __typename?: 'Query', findDuplicates: { __typename?: 'FindDuplicatesResult', totalGroupsFound: number, analyzedNodeCount: number, groups: Array<{ __typename?: 'DuplicateGroup', id: string, confidence: number, nodes: Array<{ __typename?: 'DuplicateNodeInfo', id: string, displayName: string, typeName?: string | null, properties?: any | null }>, pairs: Array<{ __typename?: 'DuplicatePair', nodeA: string, nodeB: string, score: number, signals: Array<{ __typename?: 'DuplicateMatchSignal', type: string, detail: string, score: number }> }> }> } };

export type PermissionRulesQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type PermissionRulesQuery = { __typename?: 'Query', permissionRules: Array<{ __typename?: 'PermissionRule', id: string, name: string, subjectKind: PermissionSubjectKind, subjectId?: string | null, level: PermissionLevel, priority: number, source: PermissionSource, locked: boolean, description?: string | null, scope: { __typename?: 'PermissionScope', kind: PermissionScopeKind, nodeId?: string | null, nodeType?: string | null, tag?: string | null, name?: string | null, propId?: string | null, propName?: string | null, edgeId?: string | null, predicate?: any | null } }> };

export type PermissionSubjectsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type PermissionSubjectsQuery = { __typename?: 'Query', permissionSubjects: { __typename?: 'PermissionSubjects', users: Array<{ __typename?: 'PermissionSubjectUser', id: string, name: string, roleId?: string | null, teamIds: Array<string>, isAdmin: boolean }>, teams: Array<{ __typename?: 'PermissionSubjectTeam', id: string, name: string, color?: string | null, memberIds: Array<string> }>, roles: Array<{ __typename?: 'Role', id: string, name: string, description?: string | null, color?: string | null, isSystem: boolean }> } };

export type EffectiveNodeAccessQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  nodeId: Scalars['ID']['input'];
  subject?: InputMaybe<PreviewSubjectInput>;
}>;


export type EffectiveNodeAccessQuery = { __typename?: 'Query', effectiveNodeAccess?: { __typename?: 'EffectiveAccess', nodeId: string, level: PermissionLevel, properties: Array<{ __typename?: 'EffectivePropertyAccess', key: string, access: PermissionLevel }>, edges: Array<{ __typename?: 'EffectiveEdgeAccess', edgeId: string, access: PermissionLevel, properties: Array<{ __typename?: 'EffectivePropertyAccess', key: string, access: PermissionLevel }> }> } | null };

export type CreatePermissionRuleMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  input: CreatePermissionRuleInput;
}>;


export type CreatePermissionRuleMutation = { __typename?: 'Mutation', createPermissionRule: { __typename?: 'PermissionRule', id: string, name: string, subjectKind: PermissionSubjectKind, subjectId?: string | null, level: PermissionLevel, priority: number, source: PermissionSource, locked: boolean, description?: string | null, scope: { __typename?: 'PermissionScope', kind: PermissionScopeKind, nodeId?: string | null, nodeType?: string | null, tag?: string | null, name?: string | null, propId?: string | null, propName?: string | null, edgeId?: string | null, predicate?: any | null } } };

export type UpdatePermissionRuleMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  input: UpdatePermissionRuleInput;
}>;


export type UpdatePermissionRuleMutation = { __typename?: 'Mutation', updatePermissionRule: { __typename?: 'PermissionRule', id: string, name: string, subjectKind: PermissionSubjectKind, subjectId?: string | null, level: PermissionLevel, priority: number, source: PermissionSource, locked: boolean, description?: string | null, scope: { __typename?: 'PermissionScope', kind: PermissionScopeKind, nodeId?: string | null, nodeType?: string | null, tag?: string | null, name?: string | null, propId?: string | null, propName?: string | null, edgeId?: string | null, predicate?: any | null } } };

export type DeletePermissionRuleMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type DeletePermissionRuleMutation = { __typename?: 'Mutation', deletePermissionRule: string };

export type CreateTeamMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateTeamMutation = { __typename?: 'Mutation', createTeam: { __typename?: 'Team', id: string, name: string, color?: string | null } };

export type AddTeamMemberMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type AddTeamMemberMutation = { __typename?: 'Mutation', addTeamMember: boolean };

export type RemoveTeamMemberMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type RemoveTeamMemberMutation = { __typename?: 'Mutation', removeTeamMember: boolean };

export type CreateRoleMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateRoleMutation = { __typename?: 'Mutation', createRole: { __typename?: 'Role', id: string, name: string, description?: string | null, color?: string | null, isSystem: boolean } };

export type AssignRoleMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  roleId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AssignRoleMutation = { __typename?: 'Mutation', assignRole: boolean };

export type GetEdgeDetailQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  edgeId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetEdgeDetailQuery = { __typename?: 'Query', edge?: { __typename?: 'Edge', id: string, organizationId: string, sourceNode: string, targetNode: string, strength?: number | null, primaryNature?: string | null, publicSummary?: string | null, publicSummaryGeneratedAt?: any | null, lastEventAt?: any | null, eventCount: number, source?: { __typename?: 'Node', id: string, displayName: string, typeName?: string | null } | null, target?: { __typename?: 'Node', id: string, displayName: string, typeName?: string | null } | null, topOfMindEvents: Array<{ __typename?: 'Event', id: string, eventType: string, occurredAt?: any | null, createdAt: any, source: string, payload?: any | null, participations: Array<{ __typename?: 'EventParticipation', role: string, node: { __typename?: 'Node', id: string, displayName: string } }> }>, events: { __typename?: 'EventConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'EventEdge', cursor: string, node: { __typename?: 'Event', id: string, eventType: string, occurredAt?: any | null, createdAt: any, source: string, payload?: any | null, participations: Array<{ __typename?: 'EventParticipation', role: string, node: { __typename?: 'Node', id: string, displayName: string } }> } }> }, privateContext?: { __typename?: 'EdgePrivateContext', privateSummary?: string | null, generatedAt?: any | null, topOfMindEvents: Array<{ __typename?: 'Event', id: string, eventType: string, occurredAt?: any | null, createdAt: any, source: string, payload?: any | null, participations: Array<{ __typename?: 'EventParticipation', role: string, node: { __typename?: 'Node', id: string, displayName: string } }> }> } | null } | null };

export type GetEdgeSummaryStatusQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  edgeId: Scalars['ID']['input'];
}>;


export type GetEdgeSummaryStatusQuery = { __typename?: 'Query', edge?: { __typename?: 'Edge', id: string, strength?: number | null, primaryNature?: string | null, publicSummary?: string | null, publicSummaryGeneratedAt?: any | null, lastEventAt?: any | null, eventCount: number } | null };

export type GetNodeConnectionsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  nodeId: Scalars['ID']['input'];
}>;


export type GetNodeConnectionsQuery = { __typename?: 'Query', node?: { __typename?: 'Node', id: string, edges: Array<{ __typename?: 'Edge', id: string, publicSummary?: string | null }> } | null };

export type GetEventsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetEventsQuery = { __typename?: 'Query', events: Array<{ __typename?: 'Event', id: string, eventType: string, occurredAt?: any | null, createdAt: any, source: string, payload?: any | null, participations: Array<{ __typename?: 'EventParticipation', role: string, node: { __typename?: 'Node', id: string, displayName: string } }> }> };

export type CreateManualNoteEventMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  input: CreateManualNoteEventInput;
}>;


export type CreateManualNoteEventMutation = { __typename?: 'Mutation', createManualNoteEvent: { __typename?: 'CreateManualNoteEventPayload', event: { __typename?: 'Event', id: string, eventType: string, occurredAt?: any | null, createdAt: any, source: string, payload?: any | null, participations: Array<{ __typename?: 'EventParticipation', role: string, node: { __typename?: 'Node', id: string, displayName: string } }> }, affectedEdges: Array<{ __typename?: 'Edge', id: string, strength?: number | null, primaryNature?: string | null, publicSummary?: string | null, publicSummaryGeneratedAt?: any | null, lastEventAt?: any | null, eventCount: number }> } };

export type RefreshEdgeSummaryMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  edgeId: Scalars['ID']['input'];
}>;


export type RefreshEdgeSummaryMutation = { __typename?: 'Mutation', refreshEdgeSummary?: { __typename?: 'Edge', id: string, strength?: number | null, primaryNature?: string | null, publicSummary?: string | null, publicSummaryGeneratedAt?: any | null, lastEventAt?: any | null, eventCount: number, topOfMindEvents: Array<{ __typename?: 'Event', id: string, eventType: string, occurredAt?: any | null, createdAt: any, source: string, payload?: any | null, participations: Array<{ __typename?: 'EventParticipation', role: string, node: { __typename?: 'Node', id: string, displayName: string } }> }>, privateContext?: { __typename?: 'EdgePrivateContext', privateSummary?: string | null, generatedAt?: any | null, topOfMindEvents: Array<{ __typename?: 'Event', id: string, eventType: string, occurredAt?: any | null, createdAt: any, source: string, payload?: any | null, participations: Array<{ __typename?: 'EventParticipation', role: string, node: { __typename?: 'Node', id: string, displayName: string } }> }> } | null } | null };


export const GetCurrentUserAndOrganizationsDocument = gql`
    query GetCurrentUserAndOrganizations {
  currentUser {
    id
    firstName
    lastName
    displayName
    email
    phone
    betaAccessStatus
    isEmployee
    createdAt
    updatedAt
  }
  organizations {
    id
    name
    websiteUrl
    role
    nodeId
  }
}
    `;

/**
 * __useGetCurrentUserAndOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserAndOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserAndOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserAndOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserAndOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserAndOrganizationsQuery, GetCurrentUserAndOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserAndOrganizationsQuery, GetCurrentUserAndOrganizationsQueryVariables>(GetCurrentUserAndOrganizationsDocument, options);
      }
export function useGetCurrentUserAndOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserAndOrganizationsQuery, GetCurrentUserAndOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserAndOrganizationsQuery, GetCurrentUserAndOrganizationsQueryVariables>(GetCurrentUserAndOrganizationsDocument, options);
        }
// @ts-ignore
export function useGetCurrentUserAndOrganizationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentUserAndOrganizationsQuery, GetCurrentUserAndOrganizationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCurrentUserAndOrganizationsQuery, GetCurrentUserAndOrganizationsQueryVariables>;
export function useGetCurrentUserAndOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserAndOrganizationsQuery, GetCurrentUserAndOrganizationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCurrentUserAndOrganizationsQuery | undefined, GetCurrentUserAndOrganizationsQueryVariables>;
export function useGetCurrentUserAndOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserAndOrganizationsQuery, GetCurrentUserAndOrganizationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserAndOrganizationsQuery, GetCurrentUserAndOrganizationsQueryVariables>(GetCurrentUserAndOrganizationsDocument, options);
        }
export type GetCurrentUserAndOrganizationsQueryHookResult = ReturnType<typeof useGetCurrentUserAndOrganizationsQuery>;
export type GetCurrentUserAndOrganizationsLazyQueryHookResult = ReturnType<typeof useGetCurrentUserAndOrganizationsLazyQuery>;
export type GetCurrentUserAndOrganizationsSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserAndOrganizationsSuspenseQuery>;
export type GetCurrentUserAndOrganizationsQueryResult = Apollo.QueryResult<GetCurrentUserAndOrganizationsQuery, GetCurrentUserAndOrganizationsQueryVariables>;
export const GetWaitlistUsersDocument = gql`
    query GetWaitlistUsers {
  waitlistUsers {
    id
    firstName
    lastName
    displayName
    email
    createdAt
  }
}
    `;

/**
 * __useGetWaitlistUsersQuery__
 *
 * To run a query within a React component, call `useGetWaitlistUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWaitlistUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWaitlistUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWaitlistUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetWaitlistUsersQuery, GetWaitlistUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWaitlistUsersQuery, GetWaitlistUsersQueryVariables>(GetWaitlistUsersDocument, options);
      }
export function useGetWaitlistUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWaitlistUsersQuery, GetWaitlistUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWaitlistUsersQuery, GetWaitlistUsersQueryVariables>(GetWaitlistUsersDocument, options);
        }
// @ts-ignore
export function useGetWaitlistUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWaitlistUsersQuery, GetWaitlistUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetWaitlistUsersQuery, GetWaitlistUsersQueryVariables>;
export function useGetWaitlistUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWaitlistUsersQuery, GetWaitlistUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetWaitlistUsersQuery | undefined, GetWaitlistUsersQueryVariables>;
export function useGetWaitlistUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWaitlistUsersQuery, GetWaitlistUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWaitlistUsersQuery, GetWaitlistUsersQueryVariables>(GetWaitlistUsersDocument, options);
        }
export type GetWaitlistUsersQueryHookResult = ReturnType<typeof useGetWaitlistUsersQuery>;
export type GetWaitlistUsersLazyQueryHookResult = ReturnType<typeof useGetWaitlistUsersLazyQuery>;
export type GetWaitlistUsersSuspenseQueryHookResult = ReturnType<typeof useGetWaitlistUsersSuspenseQuery>;
export type GetWaitlistUsersQueryResult = Apollo.QueryResult<GetWaitlistUsersQuery, GetWaitlistUsersQueryVariables>;
export const ApproveWaitlistUserDocument = gql`
    mutation ApproveWaitlistUser($userId: ID!) {
  approveWaitlistUser(userId: $userId) {
    id
    email
    betaAccessStatus
  }
}
    `;
export type ApproveWaitlistUserMutationFn = Apollo.MutationFunction<ApproveWaitlistUserMutation, ApproveWaitlistUserMutationVariables>;

/**
 * __useApproveWaitlistUserMutation__
 *
 * To run a mutation, you first call `useApproveWaitlistUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveWaitlistUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveWaitlistUserMutation, { data, loading, error }] = useApproveWaitlistUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useApproveWaitlistUserMutation(baseOptions?: Apollo.MutationHookOptions<ApproveWaitlistUserMutation, ApproveWaitlistUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveWaitlistUserMutation, ApproveWaitlistUserMutationVariables>(ApproveWaitlistUserDocument, options);
      }
export type ApproveWaitlistUserMutationHookResult = ReturnType<typeof useApproveWaitlistUserMutation>;
export type ApproveWaitlistUserMutationResult = Apollo.MutationResult<ApproveWaitlistUserMutation>;
export type ApproveWaitlistUserMutationOptions = Apollo.BaseMutationOptions<ApproveWaitlistUserMutation, ApproveWaitlistUserMutationVariables>;
export const EmployeeGetUsersDocument = gql`
    query EmployeeGetUsers($search: String, $limit: Int, $offset: Int) {
  employeeUsers(search: $search, limit: $limit, offset: $offset) {
    users {
      id
      firstName
      lastName
      displayName
      email
      phone
      betaAccessStatus
      isEmployee
      createdAt
      updatedAt
      memberships {
        organization {
          id
          name
        }
        role
        createdAt
      }
    }
    totalCount
  }
}
    `;

/**
 * __useEmployeeGetUsersQuery__
 *
 * To run a query within a React component, call `useEmployeeGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeGetUsersQuery({
 *   variables: {
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useEmployeeGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<EmployeeGetUsersQuery, EmployeeGetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeGetUsersQuery, EmployeeGetUsersQueryVariables>(EmployeeGetUsersDocument, options);
      }
export function useEmployeeGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeGetUsersQuery, EmployeeGetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeGetUsersQuery, EmployeeGetUsersQueryVariables>(EmployeeGetUsersDocument, options);
        }
// @ts-ignore
export function useEmployeeGetUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeGetUsersQuery, EmployeeGetUsersQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeGetUsersQuery, EmployeeGetUsersQueryVariables>;
export function useEmployeeGetUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeGetUsersQuery, EmployeeGetUsersQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeGetUsersQuery | undefined, EmployeeGetUsersQueryVariables>;
export function useEmployeeGetUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeGetUsersQuery, EmployeeGetUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeGetUsersQuery, EmployeeGetUsersQueryVariables>(EmployeeGetUsersDocument, options);
        }
export type EmployeeGetUsersQueryHookResult = ReturnType<typeof useEmployeeGetUsersQuery>;
export type EmployeeGetUsersLazyQueryHookResult = ReturnType<typeof useEmployeeGetUsersLazyQuery>;
export type EmployeeGetUsersSuspenseQueryHookResult = ReturnType<typeof useEmployeeGetUsersSuspenseQuery>;
export type EmployeeGetUsersQueryResult = Apollo.QueryResult<EmployeeGetUsersQuery, EmployeeGetUsersQueryVariables>;
export const EmployeeGetUserDocument = gql`
    query EmployeeGetUser($id: ID!) {
  employeeUser(id: $id) {
    id
    firstName
    lastName
    displayName
    email
    phone
    betaAccessStatus
    isEmployee
    createdAt
    updatedAt
    memberships {
      organization {
        id
        name
      }
      role
      createdAt
    }
    aiCostUsd
    lastActiveAt
    activeDatesLast30Days
  }
}
    `;

/**
 * __useEmployeeGetUserQuery__
 *
 * To run a query within a React component, call `useEmployeeGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmployeeGetUserQuery(baseOptions: Apollo.QueryHookOptions<EmployeeGetUserQuery, EmployeeGetUserQueryVariables> & ({ variables: EmployeeGetUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeGetUserQuery, EmployeeGetUserQueryVariables>(EmployeeGetUserDocument, options);
      }
export function useEmployeeGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeGetUserQuery, EmployeeGetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeGetUserQuery, EmployeeGetUserQueryVariables>(EmployeeGetUserDocument, options);
        }
// @ts-ignore
export function useEmployeeGetUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeGetUserQuery, EmployeeGetUserQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeGetUserQuery, EmployeeGetUserQueryVariables>;
export function useEmployeeGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeGetUserQuery, EmployeeGetUserQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeGetUserQuery | undefined, EmployeeGetUserQueryVariables>;
export function useEmployeeGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeGetUserQuery, EmployeeGetUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeGetUserQuery, EmployeeGetUserQueryVariables>(EmployeeGetUserDocument, options);
        }
export type EmployeeGetUserQueryHookResult = ReturnType<typeof useEmployeeGetUserQuery>;
export type EmployeeGetUserLazyQueryHookResult = ReturnType<typeof useEmployeeGetUserLazyQuery>;
export type EmployeeGetUserSuspenseQueryHookResult = ReturnType<typeof useEmployeeGetUserSuspenseQuery>;
export type EmployeeGetUserQueryResult = Apollo.QueryResult<EmployeeGetUserQuery, EmployeeGetUserQueryVariables>;
export const EmployeeGetOrganizationsDocument = gql`
    query EmployeeGetOrganizations($search: String, $limit: Int, $offset: Int) {
  employeeOrganizations(search: $search, limit: $limit, offset: $offset) {
    organizations {
      id
      name
      websiteUrl
      workosId
      createdAt
      updatedAt
      members {
        user {
          id
          displayName
          email
        }
        role
        createdAt
      }
    }
    totalCount
  }
}
    `;

/**
 * __useEmployeeGetOrganizationsQuery__
 *
 * To run a query within a React component, call `useEmployeeGetOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeGetOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeGetOrganizationsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useEmployeeGetOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<EmployeeGetOrganizationsQuery, EmployeeGetOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeGetOrganizationsQuery, EmployeeGetOrganizationsQueryVariables>(EmployeeGetOrganizationsDocument, options);
      }
export function useEmployeeGetOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeGetOrganizationsQuery, EmployeeGetOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeGetOrganizationsQuery, EmployeeGetOrganizationsQueryVariables>(EmployeeGetOrganizationsDocument, options);
        }
// @ts-ignore
export function useEmployeeGetOrganizationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeGetOrganizationsQuery, EmployeeGetOrganizationsQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeGetOrganizationsQuery, EmployeeGetOrganizationsQueryVariables>;
export function useEmployeeGetOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeGetOrganizationsQuery, EmployeeGetOrganizationsQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeGetOrganizationsQuery | undefined, EmployeeGetOrganizationsQueryVariables>;
export function useEmployeeGetOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeGetOrganizationsQuery, EmployeeGetOrganizationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeGetOrganizationsQuery, EmployeeGetOrganizationsQueryVariables>(EmployeeGetOrganizationsDocument, options);
        }
export type EmployeeGetOrganizationsQueryHookResult = ReturnType<typeof useEmployeeGetOrganizationsQuery>;
export type EmployeeGetOrganizationsLazyQueryHookResult = ReturnType<typeof useEmployeeGetOrganizationsLazyQuery>;
export type EmployeeGetOrganizationsSuspenseQueryHookResult = ReturnType<typeof useEmployeeGetOrganizationsSuspenseQuery>;
export type EmployeeGetOrganizationsQueryResult = Apollo.QueryResult<EmployeeGetOrganizationsQuery, EmployeeGetOrganizationsQueryVariables>;
export const EmployeeGetOrganizationDocument = gql`
    query EmployeeGetOrganization($id: ID!) {
  employeeOrganization(id: $id) {
    id
    name
    websiteUrl
    workosId
    createdAt
    updatedAt
    members {
      user {
        id
        displayName
        email
      }
      role
      createdAt
      lastActiveAt
    }
    aiCostUsd
  }
}
    `;

/**
 * __useEmployeeGetOrganizationQuery__
 *
 * To run a query within a React component, call `useEmployeeGetOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeGetOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeGetOrganizationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmployeeGetOrganizationQuery(baseOptions: Apollo.QueryHookOptions<EmployeeGetOrganizationQuery, EmployeeGetOrganizationQueryVariables> & ({ variables: EmployeeGetOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeGetOrganizationQuery, EmployeeGetOrganizationQueryVariables>(EmployeeGetOrganizationDocument, options);
      }
export function useEmployeeGetOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeGetOrganizationQuery, EmployeeGetOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeGetOrganizationQuery, EmployeeGetOrganizationQueryVariables>(EmployeeGetOrganizationDocument, options);
        }
// @ts-ignore
export function useEmployeeGetOrganizationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeGetOrganizationQuery, EmployeeGetOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeGetOrganizationQuery, EmployeeGetOrganizationQueryVariables>;
export function useEmployeeGetOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeGetOrganizationQuery, EmployeeGetOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeGetOrganizationQuery | undefined, EmployeeGetOrganizationQueryVariables>;
export function useEmployeeGetOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeGetOrganizationQuery, EmployeeGetOrganizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeGetOrganizationQuery, EmployeeGetOrganizationQueryVariables>(EmployeeGetOrganizationDocument, options);
        }
export type EmployeeGetOrganizationQueryHookResult = ReturnType<typeof useEmployeeGetOrganizationQuery>;
export type EmployeeGetOrganizationLazyQueryHookResult = ReturnType<typeof useEmployeeGetOrganizationLazyQuery>;
export type EmployeeGetOrganizationSuspenseQueryHookResult = ReturnType<typeof useEmployeeGetOrganizationSuspenseQuery>;
export type EmployeeGetOrganizationQueryResult = Apollo.QueryResult<EmployeeGetOrganizationQuery, EmployeeGetOrganizationQueryVariables>;
export const EmployeeSetUserEmployeeDocument = gql`
    mutation EmployeeSetUserEmployee($userId: ID!, $isEmployee: Boolean!) {
  employeeSetUserEmployee(userId: $userId, isEmployee: $isEmployee) {
    id
    isEmployee
  }
}
    `;
export type EmployeeSetUserEmployeeMutationFn = Apollo.MutationFunction<EmployeeSetUserEmployeeMutation, EmployeeSetUserEmployeeMutationVariables>;

/**
 * __useEmployeeSetUserEmployeeMutation__
 *
 * To run a mutation, you first call `useEmployeeSetUserEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmployeeSetUserEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employeeSetUserEmployeeMutation, { data, loading, error }] = useEmployeeSetUserEmployeeMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      isEmployee: // value for 'isEmployee'
 *   },
 * });
 */
export function useEmployeeSetUserEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<EmployeeSetUserEmployeeMutation, EmployeeSetUserEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmployeeSetUserEmployeeMutation, EmployeeSetUserEmployeeMutationVariables>(EmployeeSetUserEmployeeDocument, options);
      }
export type EmployeeSetUserEmployeeMutationHookResult = ReturnType<typeof useEmployeeSetUserEmployeeMutation>;
export type EmployeeSetUserEmployeeMutationResult = Apollo.MutationResult<EmployeeSetUserEmployeeMutation>;
export type EmployeeSetUserEmployeeMutationOptions = Apollo.BaseMutationOptions<EmployeeSetUserEmployeeMutation, EmployeeSetUserEmployeeMutationVariables>;
export const EmployeeDeleteUserDocument = gql`
    mutation EmployeeDeleteUser($userId: ID!) {
  employeeDeleteUser(userId: $userId)
}
    `;
export type EmployeeDeleteUserMutationFn = Apollo.MutationFunction<EmployeeDeleteUserMutation, EmployeeDeleteUserMutationVariables>;

/**
 * __useEmployeeDeleteUserMutation__
 *
 * To run a mutation, you first call `useEmployeeDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmployeeDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employeeDeleteUserMutation, { data, loading, error }] = useEmployeeDeleteUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useEmployeeDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<EmployeeDeleteUserMutation, EmployeeDeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmployeeDeleteUserMutation, EmployeeDeleteUserMutationVariables>(EmployeeDeleteUserDocument, options);
      }
export type EmployeeDeleteUserMutationHookResult = ReturnType<typeof useEmployeeDeleteUserMutation>;
export type EmployeeDeleteUserMutationResult = Apollo.MutationResult<EmployeeDeleteUserMutation>;
export type EmployeeDeleteUserMutationOptions = Apollo.BaseMutationOptions<EmployeeDeleteUserMutation, EmployeeDeleteUserMutationVariables>;
export const EmployeeDeleteOrganizationDocument = gql`
    mutation EmployeeDeleteOrganization($organizationId: ID!) {
  employeeDeleteOrganization(organizationId: $organizationId)
}
    `;
export type EmployeeDeleteOrganizationMutationFn = Apollo.MutationFunction<EmployeeDeleteOrganizationMutation, EmployeeDeleteOrganizationMutationVariables>;

/**
 * __useEmployeeDeleteOrganizationMutation__
 *
 * To run a mutation, you first call `useEmployeeDeleteOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmployeeDeleteOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employeeDeleteOrganizationMutation, { data, loading, error }] = useEmployeeDeleteOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useEmployeeDeleteOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<EmployeeDeleteOrganizationMutation, EmployeeDeleteOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmployeeDeleteOrganizationMutation, EmployeeDeleteOrganizationMutationVariables>(EmployeeDeleteOrganizationDocument, options);
      }
export type EmployeeDeleteOrganizationMutationHookResult = ReturnType<typeof useEmployeeDeleteOrganizationMutation>;
export type EmployeeDeleteOrganizationMutationResult = Apollo.MutationResult<EmployeeDeleteOrganizationMutation>;
export type EmployeeDeleteOrganizationMutationOptions = Apollo.BaseMutationOptions<EmployeeDeleteOrganizationMutation, EmployeeDeleteOrganizationMutationVariables>;
export const GetAdminScriptsDocument = gql`
    query GetAdminScripts {
  adminScripts {
    name
    displayName
    description
    dangerous
    params {
      key
      label
      description
      type
      required
    }
  }
}
    `;

/**
 * __useGetAdminScriptsQuery__
 *
 * To run a query within a React component, call `useGetAdminScriptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminScriptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminScriptsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdminScriptsQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminScriptsQuery, GetAdminScriptsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminScriptsQuery, GetAdminScriptsQueryVariables>(GetAdminScriptsDocument, options);
      }
export function useGetAdminScriptsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminScriptsQuery, GetAdminScriptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminScriptsQuery, GetAdminScriptsQueryVariables>(GetAdminScriptsDocument, options);
        }
// @ts-ignore
export function useGetAdminScriptsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminScriptsQuery, GetAdminScriptsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAdminScriptsQuery, GetAdminScriptsQueryVariables>;
export function useGetAdminScriptsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdminScriptsQuery, GetAdminScriptsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAdminScriptsQuery | undefined, GetAdminScriptsQueryVariables>;
export function useGetAdminScriptsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdminScriptsQuery, GetAdminScriptsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdminScriptsQuery, GetAdminScriptsQueryVariables>(GetAdminScriptsDocument, options);
        }
export type GetAdminScriptsQueryHookResult = ReturnType<typeof useGetAdminScriptsQuery>;
export type GetAdminScriptsLazyQueryHookResult = ReturnType<typeof useGetAdminScriptsLazyQuery>;
export type GetAdminScriptsSuspenseQueryHookResult = ReturnType<typeof useGetAdminScriptsSuspenseQuery>;
export type GetAdminScriptsQueryResult = Apollo.QueryResult<GetAdminScriptsQuery, GetAdminScriptsQueryVariables>;
export const RunAdminScriptDocument = gql`
    mutation RunAdminScript($name: String!, $input: [AdminScriptInputArg!]) {
  runAdminScript(name: $name, input: $input) {
    scriptName
    success
    message
    details {
      key
      value
    }
  }
}
    `;
export type RunAdminScriptMutationFn = Apollo.MutationFunction<RunAdminScriptMutation, RunAdminScriptMutationVariables>;

/**
 * __useRunAdminScriptMutation__
 *
 * To run a mutation, you first call `useRunAdminScriptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunAdminScriptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runAdminScriptMutation, { data, loading, error }] = useRunAdminScriptMutation({
 *   variables: {
 *      name: // value for 'name'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRunAdminScriptMutation(baseOptions?: Apollo.MutationHookOptions<RunAdminScriptMutation, RunAdminScriptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RunAdminScriptMutation, RunAdminScriptMutationVariables>(RunAdminScriptDocument, options);
      }
export type RunAdminScriptMutationHookResult = ReturnType<typeof useRunAdminScriptMutation>;
export type RunAdminScriptMutationResult = Apollo.MutationResult<RunAdminScriptMutation>;
export type RunAdminScriptMutationOptions = Apollo.BaseMutationOptions<RunAdminScriptMutation, RunAdminScriptMutationVariables>;
export const EmployeeGetActiveUserCountsDocument = gql`
    query EmployeeGetActiveUserCounts($organizationId: ID) {
  employeeActiveUserCounts(organizationId: $organizationId) {
    daily
    weekly
    monthly
  }
}
    `;

/**
 * __useEmployeeGetActiveUserCountsQuery__
 *
 * To run a query within a React component, call `useEmployeeGetActiveUserCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeGetActiveUserCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeGetActiveUserCountsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useEmployeeGetActiveUserCountsQuery(baseOptions?: Apollo.QueryHookOptions<EmployeeGetActiveUserCountsQuery, EmployeeGetActiveUserCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeGetActiveUserCountsQuery, EmployeeGetActiveUserCountsQueryVariables>(EmployeeGetActiveUserCountsDocument, options);
      }
export function useEmployeeGetActiveUserCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeGetActiveUserCountsQuery, EmployeeGetActiveUserCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeGetActiveUserCountsQuery, EmployeeGetActiveUserCountsQueryVariables>(EmployeeGetActiveUserCountsDocument, options);
        }
// @ts-ignore
export function useEmployeeGetActiveUserCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeGetActiveUserCountsQuery, EmployeeGetActiveUserCountsQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeGetActiveUserCountsQuery, EmployeeGetActiveUserCountsQueryVariables>;
export function useEmployeeGetActiveUserCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeGetActiveUserCountsQuery, EmployeeGetActiveUserCountsQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeGetActiveUserCountsQuery | undefined, EmployeeGetActiveUserCountsQueryVariables>;
export function useEmployeeGetActiveUserCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeGetActiveUserCountsQuery, EmployeeGetActiveUserCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeGetActiveUserCountsQuery, EmployeeGetActiveUserCountsQueryVariables>(EmployeeGetActiveUserCountsDocument, options);
        }
export type EmployeeGetActiveUserCountsQueryHookResult = ReturnType<typeof useEmployeeGetActiveUserCountsQuery>;
export type EmployeeGetActiveUserCountsLazyQueryHookResult = ReturnType<typeof useEmployeeGetActiveUserCountsLazyQuery>;
export type EmployeeGetActiveUserCountsSuspenseQueryHookResult = ReturnType<typeof useEmployeeGetActiveUserCountsSuspenseQuery>;
export type EmployeeGetActiveUserCountsQueryResult = Apollo.QueryResult<EmployeeGetActiveUserCountsQuery, EmployeeGetActiveUserCountsQueryVariables>;
export const EmployeeGetUserActivityDocument = gql`
    query EmployeeGetUserActivity($organizationId: ID, $search: String, $days: Int, $orderBy: UserActivityOrderBy, $limit: Int, $offset: Int) {
  employeeUserActivity(
    organizationId: $organizationId
    search: $search
    days: $days
    orderBy: $orderBy
    limit: $limit
    offset: $offset
  ) {
    users {
      userId
      displayName
      email
      activeDates
      lastActiveAt
    }
    totalCount
  }
}
    `;

/**
 * __useEmployeeGetUserActivityQuery__
 *
 * To run a query within a React component, call `useEmployeeGetUserActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeGetUserActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeGetUserActivityQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      search: // value for 'search'
 *      days: // value for 'days'
 *      orderBy: // value for 'orderBy'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useEmployeeGetUserActivityQuery(baseOptions?: Apollo.QueryHookOptions<EmployeeGetUserActivityQuery, EmployeeGetUserActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeGetUserActivityQuery, EmployeeGetUserActivityQueryVariables>(EmployeeGetUserActivityDocument, options);
      }
export function useEmployeeGetUserActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeGetUserActivityQuery, EmployeeGetUserActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeGetUserActivityQuery, EmployeeGetUserActivityQueryVariables>(EmployeeGetUserActivityDocument, options);
        }
// @ts-ignore
export function useEmployeeGetUserActivitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeGetUserActivityQuery, EmployeeGetUserActivityQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeGetUserActivityQuery, EmployeeGetUserActivityQueryVariables>;
export function useEmployeeGetUserActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeGetUserActivityQuery, EmployeeGetUserActivityQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeGetUserActivityQuery | undefined, EmployeeGetUserActivityQueryVariables>;
export function useEmployeeGetUserActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeGetUserActivityQuery, EmployeeGetUserActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeGetUserActivityQuery, EmployeeGetUserActivityQueryVariables>(EmployeeGetUserActivityDocument, options);
        }
export type EmployeeGetUserActivityQueryHookResult = ReturnType<typeof useEmployeeGetUserActivityQuery>;
export type EmployeeGetUserActivityLazyQueryHookResult = ReturnType<typeof useEmployeeGetUserActivityLazyQuery>;
export type EmployeeGetUserActivitySuspenseQueryHookResult = ReturnType<typeof useEmployeeGetUserActivitySuspenseQuery>;
export type EmployeeGetUserActivityQueryResult = Apollo.QueryResult<EmployeeGetUserActivityQuery, EmployeeGetUserActivityQueryVariables>;
export const EmployeeGetAiUsageDocument = gql`
    query EmployeeGetAiUsage($filter: EmployeeAiUsageFilter, $limit: Int, $offset: Int) {
  employeeAiUsage(filter: $filter, limit: $limit, offset: $offset) {
    items {
      id
      model
      operation
      promptTokens
      completionTokens
      totalTokens
      durationMs
      costUsd
      createdAt
      user {
        id
        displayName
        email
      }
      organization {
        id
        name
      }
    }
    totalCount
    summary {
      totalCalls
      totalPromptTokens
      totalCompletionTokens
      totalTokens
      totalCostUsd
      avgDurationMs
    }
  }
}
    `;

/**
 * __useEmployeeGetAiUsageQuery__
 *
 * To run a query within a React component, call `useEmployeeGetAiUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeGetAiUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeGetAiUsageQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useEmployeeGetAiUsageQuery(baseOptions?: Apollo.QueryHookOptions<EmployeeGetAiUsageQuery, EmployeeGetAiUsageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeGetAiUsageQuery, EmployeeGetAiUsageQueryVariables>(EmployeeGetAiUsageDocument, options);
      }
export function useEmployeeGetAiUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeGetAiUsageQuery, EmployeeGetAiUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeGetAiUsageQuery, EmployeeGetAiUsageQueryVariables>(EmployeeGetAiUsageDocument, options);
        }
// @ts-ignore
export function useEmployeeGetAiUsageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeGetAiUsageQuery, EmployeeGetAiUsageQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeGetAiUsageQuery, EmployeeGetAiUsageQueryVariables>;
export function useEmployeeGetAiUsageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeGetAiUsageQuery, EmployeeGetAiUsageQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeGetAiUsageQuery | undefined, EmployeeGetAiUsageQueryVariables>;
export function useEmployeeGetAiUsageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeGetAiUsageQuery, EmployeeGetAiUsageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeGetAiUsageQuery, EmployeeGetAiUsageQueryVariables>(EmployeeGetAiUsageDocument, options);
        }
export type EmployeeGetAiUsageQueryHookResult = ReturnType<typeof useEmployeeGetAiUsageQuery>;
export type EmployeeGetAiUsageLazyQueryHookResult = ReturnType<typeof useEmployeeGetAiUsageLazyQuery>;
export type EmployeeGetAiUsageSuspenseQueryHookResult = ReturnType<typeof useEmployeeGetAiUsageSuspenseQuery>;
export type EmployeeGetAiUsageQueryResult = Apollo.QueryResult<EmployeeGetAiUsageQuery, EmployeeGetAiUsageQueryVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($id: ID!, $input: UpdateUserInput!) {
  updateUser(id: $id, input: $input) {
    id
    firstName
    lastName
    displayName
    email
    phone
    createdAt
    updatedAt
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser($id: ID!) {
  deleteUser(id: $id) {
    id
    email
  }
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const UpdateOrganizationDocument = gql`
    mutation UpdateOrganization($id: ID!, $input: UpdateOrganizationInput!) {
  updateOrganization(id: $id, input: $input) {
    id
    name
    websiteUrl
    createdAt
    updatedAt
  }
}
    `;
export type UpdateOrganizationMutationFn = Apollo.MutationFunction<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(UpdateOrganizationDocument, options);
      }
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = Apollo.MutationResult<UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const UpdateUserNodeDocument = gql`
    mutation UpdateUserNode($organizationId: ID!, $nodeId: ID) {
  updateUserNode(organizationId: $organizationId, nodeId: $nodeId) {
    id
    name
    role
    nodeId
  }
}
    `;
export type UpdateUserNodeMutationFn = Apollo.MutationFunction<UpdateUserNodeMutation, UpdateUserNodeMutationVariables>;

/**
 * __useUpdateUserNodeMutation__
 *
 * To run a mutation, you first call `useUpdateUserNodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserNodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserNodeMutation, { data, loading, error }] = useUpdateUserNodeMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useUpdateUserNodeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserNodeMutation, UpdateUserNodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserNodeMutation, UpdateUserNodeMutationVariables>(UpdateUserNodeDocument, options);
      }
export type UpdateUserNodeMutationHookResult = ReturnType<typeof useUpdateUserNodeMutation>;
export type UpdateUserNodeMutationResult = Apollo.MutationResult<UpdateUserNodeMutation>;
export type UpdateUserNodeMutationOptions = Apollo.BaseMutationOptions<UpdateUserNodeMutation, UpdateUserNodeMutationVariables>;
export const GetDistinctNodeTypeNamesDocument = gql`
    query GetDistinctNodeTypeNames($organizationId: ID!) {
  distinctNodeTypeNames(organizationId: $organizationId)
}
    `;

/**
 * __useGetDistinctNodeTypeNamesQuery__
 *
 * To run a query within a React component, call `useGetDistinctNodeTypeNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistinctNodeTypeNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistinctNodeTypeNamesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetDistinctNodeTypeNamesQuery(baseOptions: Apollo.QueryHookOptions<GetDistinctNodeTypeNamesQuery, GetDistinctNodeTypeNamesQueryVariables> & ({ variables: GetDistinctNodeTypeNamesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDistinctNodeTypeNamesQuery, GetDistinctNodeTypeNamesQueryVariables>(GetDistinctNodeTypeNamesDocument, options);
      }
export function useGetDistinctNodeTypeNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDistinctNodeTypeNamesQuery, GetDistinctNodeTypeNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDistinctNodeTypeNamesQuery, GetDistinctNodeTypeNamesQueryVariables>(GetDistinctNodeTypeNamesDocument, options);
        }
// @ts-ignore
export function useGetDistinctNodeTypeNamesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDistinctNodeTypeNamesQuery, GetDistinctNodeTypeNamesQueryVariables>): Apollo.UseSuspenseQueryResult<GetDistinctNodeTypeNamesQuery, GetDistinctNodeTypeNamesQueryVariables>;
export function useGetDistinctNodeTypeNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDistinctNodeTypeNamesQuery, GetDistinctNodeTypeNamesQueryVariables>): Apollo.UseSuspenseQueryResult<GetDistinctNodeTypeNamesQuery | undefined, GetDistinctNodeTypeNamesQueryVariables>;
export function useGetDistinctNodeTypeNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDistinctNodeTypeNamesQuery, GetDistinctNodeTypeNamesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDistinctNodeTypeNamesQuery, GetDistinctNodeTypeNamesQueryVariables>(GetDistinctNodeTypeNamesDocument, options);
        }
export type GetDistinctNodeTypeNamesQueryHookResult = ReturnType<typeof useGetDistinctNodeTypeNamesQuery>;
export type GetDistinctNodeTypeNamesLazyQueryHookResult = ReturnType<typeof useGetDistinctNodeTypeNamesLazyQuery>;
export type GetDistinctNodeTypeNamesSuspenseQueryHookResult = ReturnType<typeof useGetDistinctNodeTypeNamesSuspenseQuery>;
export type GetDistinctNodeTypeNamesQueryResult = Apollo.QueryResult<GetDistinctNodeTypeNamesQuery, GetDistinctNodeTypeNamesQueryVariables>;
export const GetNodesListDocument = gql`
    query GetNodesList($organizationId: ID!, $first: Int, $after: String, $filter: NodeFilter) {
  nodes(
    organizationId: $organizationId
    first: $first
    after: $after
    filter: $filter
  ) {
    edges {
      node {
        id
        displayName
        typeName
      }
    }
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useGetNodesListQuery__
 *
 * To run a query within a React component, call `useGetNodesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNodesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNodesListQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetNodesListQuery(baseOptions: Apollo.QueryHookOptions<GetNodesListQuery, GetNodesListQueryVariables> & ({ variables: GetNodesListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNodesListQuery, GetNodesListQueryVariables>(GetNodesListDocument, options);
      }
export function useGetNodesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNodesListQuery, GetNodesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNodesListQuery, GetNodesListQueryVariables>(GetNodesListDocument, options);
        }
// @ts-ignore
export function useGetNodesListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNodesListQuery, GetNodesListQueryVariables>): Apollo.UseSuspenseQueryResult<GetNodesListQuery, GetNodesListQueryVariables>;
export function useGetNodesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNodesListQuery, GetNodesListQueryVariables>): Apollo.UseSuspenseQueryResult<GetNodesListQuery | undefined, GetNodesListQueryVariables>;
export function useGetNodesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNodesListQuery, GetNodesListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNodesListQuery, GetNodesListQueryVariables>(GetNodesListDocument, options);
        }
export type GetNodesListQueryHookResult = ReturnType<typeof useGetNodesListQuery>;
export type GetNodesListLazyQueryHookResult = ReturnType<typeof useGetNodesListLazyQuery>;
export type GetNodesListSuspenseQueryHookResult = ReturnType<typeof useGetNodesListSuspenseQuery>;
export type GetNodesListQueryResult = Apollo.QueryResult<GetNodesListQuery, GetNodesListQueryVariables>;
export const GetNodeDocument = gql`
    query GetNode($organizationId: ID!, $nodeId: ID!) {
  node(organizationId: $organizationId, id: $nodeId) {
    id
    displayName
    typeName
    hasImage
    organizationId
  }
}
    `;

/**
 * __useGetNodeQuery__
 *
 * To run a query within a React component, call `useGetNodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNodeQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useGetNodeQuery(baseOptions: Apollo.QueryHookOptions<GetNodeQuery, GetNodeQueryVariables> & ({ variables: GetNodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNodeQuery, GetNodeQueryVariables>(GetNodeDocument, options);
      }
export function useGetNodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNodeQuery, GetNodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNodeQuery, GetNodeQueryVariables>(GetNodeDocument, options);
        }
// @ts-ignore
export function useGetNodeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNodeQuery, GetNodeQueryVariables>): Apollo.UseSuspenseQueryResult<GetNodeQuery, GetNodeQueryVariables>;
export function useGetNodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNodeQuery, GetNodeQueryVariables>): Apollo.UseSuspenseQueryResult<GetNodeQuery | undefined, GetNodeQueryVariables>;
export function useGetNodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNodeQuery, GetNodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNodeQuery, GetNodeQueryVariables>(GetNodeDocument, options);
        }
export type GetNodeQueryHookResult = ReturnType<typeof useGetNodeQuery>;
export type GetNodeLazyQueryHookResult = ReturnType<typeof useGetNodeLazyQuery>;
export type GetNodeSuspenseQueryHookResult = ReturnType<typeof useGetNodeSuspenseQuery>;
export type GetNodeQueryResult = Apollo.QueryResult<GetNodeQuery, GetNodeQueryVariables>;
export const GetNodesForVcfDocument = gql`
    query GetNodesForVcf($organizationId: ID!, $ids: [ID!]!, $first: Int!) {
  nodes(organizationId: $organizationId, filter: {ids: $ids}, first: $first) {
    edges {
      node {
        id
        displayName
        typedProperties {
          key
          value
          type
        }
      }
    }
  }
}
    `;

/**
 * __useGetNodesForVcfQuery__
 *
 * To run a query within a React component, call `useGetNodesForVcfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNodesForVcfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNodesForVcfQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      ids: // value for 'ids'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetNodesForVcfQuery(baseOptions: Apollo.QueryHookOptions<GetNodesForVcfQuery, GetNodesForVcfQueryVariables> & ({ variables: GetNodesForVcfQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNodesForVcfQuery, GetNodesForVcfQueryVariables>(GetNodesForVcfDocument, options);
      }
export function useGetNodesForVcfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNodesForVcfQuery, GetNodesForVcfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNodesForVcfQuery, GetNodesForVcfQueryVariables>(GetNodesForVcfDocument, options);
        }
// @ts-ignore
export function useGetNodesForVcfSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNodesForVcfQuery, GetNodesForVcfQueryVariables>): Apollo.UseSuspenseQueryResult<GetNodesForVcfQuery, GetNodesForVcfQueryVariables>;
export function useGetNodesForVcfSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNodesForVcfQuery, GetNodesForVcfQueryVariables>): Apollo.UseSuspenseQueryResult<GetNodesForVcfQuery | undefined, GetNodesForVcfQueryVariables>;
export function useGetNodesForVcfSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNodesForVcfQuery, GetNodesForVcfQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNodesForVcfQuery, GetNodesForVcfQueryVariables>(GetNodesForVcfDocument, options);
        }
export type GetNodesForVcfQueryHookResult = ReturnType<typeof useGetNodesForVcfQuery>;
export type GetNodesForVcfLazyQueryHookResult = ReturnType<typeof useGetNodesForVcfLazyQuery>;
export type GetNodesForVcfSuspenseQueryHookResult = ReturnType<typeof useGetNodesForVcfSuspenseQuery>;
export type GetNodesForVcfQueryResult = Apollo.QueryResult<GetNodesForVcfQuery, GetNodesForVcfQueryVariables>;
export const AddMemberDocument = gql`
    mutation AddMember($organizationId: ID!, $input: AddMemberInput!) {
  addMember(organizationId: $organizationId, input: $input)
}
    `;
export type AddMemberMutationFn = Apollo.MutationFunction<AddMemberMutation, AddMemberMutationVariables>;

/**
 * __useAddMemberMutation__
 *
 * To run a mutation, you first call `useAddMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMemberMutation, { data, loading, error }] = useAddMemberMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMemberMutation(baseOptions?: Apollo.MutationHookOptions<AddMemberMutation, AddMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMemberMutation, AddMemberMutationVariables>(AddMemberDocument, options);
      }
export type AddMemberMutationHookResult = ReturnType<typeof useAddMemberMutation>;
export type AddMemberMutationResult = Apollo.MutationResult<AddMemberMutation>;
export type AddMemberMutationOptions = Apollo.BaseMutationOptions<AddMemberMutation, AddMemberMutationVariables>;
export const RemoveMemberDocument = gql`
    mutation RemoveMember($organizationId: ID!, $userId: ID!) {
  removeMember(organizationId: $organizationId, userId: $userId)
}
    `;
export type RemoveMemberMutationFn = Apollo.MutationFunction<RemoveMemberMutation, RemoveMemberMutationVariables>;

/**
 * __useRemoveMemberMutation__
 *
 * To run a mutation, you first call `useRemoveMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMemberMutation, { data, loading, error }] = useRemoveMemberMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveMemberMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMemberMutation, RemoveMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMemberMutation, RemoveMemberMutationVariables>(RemoveMemberDocument, options);
      }
export type RemoveMemberMutationHookResult = ReturnType<typeof useRemoveMemberMutation>;
export type RemoveMemberMutationResult = Apollo.MutationResult<RemoveMemberMutation>;
export type RemoveMemberMutationOptions = Apollo.BaseMutationOptions<RemoveMemberMutation, RemoveMemberMutationVariables>;
export const UpdateMemberRoleDocument = gql`
    mutation UpdateMemberRole($organizationId: ID!, $userId: ID!, $role: OrganizationRole!) {
  updateMemberRole(organizationId: $organizationId, userId: $userId, role: $role)
}
    `;
export type UpdateMemberRoleMutationFn = Apollo.MutationFunction<UpdateMemberRoleMutation, UpdateMemberRoleMutationVariables>;

/**
 * __useUpdateMemberRoleMutation__
 *
 * To run a mutation, you first call `useUpdateMemberRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMemberRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMemberRoleMutation, { data, loading, error }] = useUpdateMemberRoleMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      userId: // value for 'userId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUpdateMemberRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMemberRoleMutation, UpdateMemberRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMemberRoleMutation, UpdateMemberRoleMutationVariables>(UpdateMemberRoleDocument, options);
      }
export type UpdateMemberRoleMutationHookResult = ReturnType<typeof useUpdateMemberRoleMutation>;
export type UpdateMemberRoleMutationResult = Apollo.MutationResult<UpdateMemberRoleMutation>;
export type UpdateMemberRoleMutationOptions = Apollo.BaseMutationOptions<UpdateMemberRoleMutation, UpdateMemberRoleMutationVariables>;
export const CreateOrganizationDocument = gql`
    mutation CreateOrganization($input: CreateOrganizationInput!) {
  createOrganization(input: $input) {
    id
    name
    websiteUrl
    workosId
    createdAt
    updatedAt
  }
}
    `;
export type CreateOrganizationMutationFn = Apollo.MutationFunction<CreateOrganizationMutation, CreateOrganizationMutationVariables>;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationMutation, CreateOrganizationMutationVariables>(CreateOrganizationDocument, options);
      }
export type CreateOrganizationMutationHookResult = ReturnType<typeof useCreateOrganizationMutation>;
export type CreateOrganizationMutationResult = Apollo.MutationResult<CreateOrganizationMutation>;
export type CreateOrganizationMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>;
export const DeleteOrganizationDocument = gql`
    mutation DeleteOrganization($id: ID!) {
  deleteOrganization(id: $id) {
    id
    name
  }
}
    `;
export type DeleteOrganizationMutationFn = Apollo.MutationFunction<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;

/**
 * __useDeleteOrganizationMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationMutation, { data, loading, error }] = useDeleteOrganizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>(DeleteOrganizationDocument, options);
      }
export type DeleteOrganizationMutationHookResult = ReturnType<typeof useDeleteOrganizationMutation>;
export type DeleteOrganizationMutationResult = Apollo.MutationResult<DeleteOrganizationMutation>;
export type DeleteOrganizationMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;
export const LeaveOrganizationDocument = gql`
    mutation LeaveOrganization($organizationId: ID!) {
  leaveOrganization(organizationId: $organizationId)
}
    `;
export type LeaveOrganizationMutationFn = Apollo.MutationFunction<LeaveOrganizationMutation, LeaveOrganizationMutationVariables>;

/**
 * __useLeaveOrganizationMutation__
 *
 * To run a mutation, you first call `useLeaveOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveOrganizationMutation, { data, loading, error }] = useLeaveOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useLeaveOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<LeaveOrganizationMutation, LeaveOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeaveOrganizationMutation, LeaveOrganizationMutationVariables>(LeaveOrganizationDocument, options);
      }
export type LeaveOrganizationMutationHookResult = ReturnType<typeof useLeaveOrganizationMutation>;
export type LeaveOrganizationMutationResult = Apollo.MutationResult<LeaveOrganizationMutation>;
export type LeaveOrganizationMutationOptions = Apollo.BaseMutationOptions<LeaveOrganizationMutation, LeaveOrganizationMutationVariables>;
export const InviteMembersByEmailDocument = gql`
    mutation InviteMembersByEmail($input: InviteMembersInput!) {
  inviteMembersByEmail(input: $input) {
    email
    status
    invite {
      inviteCode
      email
      role
      status
      isExpired
      expiresAt
      createdAt
      createdByUser {
        id
        displayName
      }
    }
  }
}
    `;
export type InviteMembersByEmailMutationFn = Apollo.MutationFunction<InviteMembersByEmailMutation, InviteMembersByEmailMutationVariables>;

/**
 * __useInviteMembersByEmailMutation__
 *
 * To run a mutation, you first call `useInviteMembersByEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteMembersByEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteMembersByEmailMutation, { data, loading, error }] = useInviteMembersByEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteMembersByEmailMutation(baseOptions?: Apollo.MutationHookOptions<InviteMembersByEmailMutation, InviteMembersByEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteMembersByEmailMutation, InviteMembersByEmailMutationVariables>(InviteMembersByEmailDocument, options);
      }
export type InviteMembersByEmailMutationHookResult = ReturnType<typeof useInviteMembersByEmailMutation>;
export type InviteMembersByEmailMutationResult = Apollo.MutationResult<InviteMembersByEmailMutation>;
export type InviteMembersByEmailMutationOptions = Apollo.BaseMutationOptions<InviteMembersByEmailMutation, InviteMembersByEmailMutationVariables>;
export const AcceptInviteDocument = gql`
    mutation AcceptInvite($inviteCode: ID!) {
  acceptInvite(inviteCode: $inviteCode) {
    organizationId
    organizationName
    alreadyMember
  }
}
    `;
export type AcceptInviteMutationFn = Apollo.MutationFunction<AcceptInviteMutation, AcceptInviteMutationVariables>;

/**
 * __useAcceptInviteMutation__
 *
 * To run a mutation, you first call `useAcceptInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptInviteMutation, { data, loading, error }] = useAcceptInviteMutation({
 *   variables: {
 *      inviteCode: // value for 'inviteCode'
 *   },
 * });
 */
export function useAcceptInviteMutation(baseOptions?: Apollo.MutationHookOptions<AcceptInviteMutation, AcceptInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptInviteMutation, AcceptInviteMutationVariables>(AcceptInviteDocument, options);
      }
export type AcceptInviteMutationHookResult = ReturnType<typeof useAcceptInviteMutation>;
export type AcceptInviteMutationResult = Apollo.MutationResult<AcceptInviteMutation>;
export type AcceptInviteMutationOptions = Apollo.BaseMutationOptions<AcceptInviteMutation, AcceptInviteMutationVariables>;
export const RevokeInviteDocument = gql`
    mutation RevokeInvite($inviteCode: ID!) {
  revokeInvite(inviteCode: $inviteCode)
}
    `;
export type RevokeInviteMutationFn = Apollo.MutationFunction<RevokeInviteMutation, RevokeInviteMutationVariables>;

/**
 * __useRevokeInviteMutation__
 *
 * To run a mutation, you first call `useRevokeInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeInviteMutation, { data, loading, error }] = useRevokeInviteMutation({
 *   variables: {
 *      inviteCode: // value for 'inviteCode'
 *   },
 * });
 */
export function useRevokeInviteMutation(baseOptions?: Apollo.MutationHookOptions<RevokeInviteMutation, RevokeInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeInviteMutation, RevokeInviteMutationVariables>(RevokeInviteDocument, options);
      }
export type RevokeInviteMutationHookResult = ReturnType<typeof useRevokeInviteMutation>;
export type RevokeInviteMutationResult = Apollo.MutationResult<RevokeInviteMutation>;
export type RevokeInviteMutationOptions = Apollo.BaseMutationOptions<RevokeInviteMutation, RevokeInviteMutationVariables>;
export const ResendInviteDocument = gql`
    mutation ResendInvite($inviteCode: ID!) {
  resendInvite(inviteCode: $inviteCode) {
    inviteCode
    status
    isExpired
    expiresAt
    lastSentAt
  }
}
    `;
export type ResendInviteMutationFn = Apollo.MutationFunction<ResendInviteMutation, ResendInviteMutationVariables>;

/**
 * __useResendInviteMutation__
 *
 * To run a mutation, you first call `useResendInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInviteMutation, { data, loading, error }] = useResendInviteMutation({
 *   variables: {
 *      inviteCode: // value for 'inviteCode'
 *   },
 * });
 */
export function useResendInviteMutation(baseOptions?: Apollo.MutationHookOptions<ResendInviteMutation, ResendInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendInviteMutation, ResendInviteMutationVariables>(ResendInviteDocument, options);
      }
export type ResendInviteMutationHookResult = ReturnType<typeof useResendInviteMutation>;
export type ResendInviteMutationResult = Apollo.MutationResult<ResendInviteMutation>;
export type ResendInviteMutationOptions = Apollo.BaseMutationOptions<ResendInviteMutation, ResendInviteMutationVariables>;
export const GetOrganizationInvitesDocument = gql`
    query GetOrganizationInvites($organizationId: ID!) {
  organizationInvites(organizationId: $organizationId) {
    inviteCode
    email
    role
    status
    isExpired
    expiresAt
    lastSentAt
    createdAt
    createdByUser {
      id
      displayName
    }
    usedAt
    usedByUser {
      id
      displayName
      email
    }
  }
}
    `;

/**
 * __useGetOrganizationInvitesQuery__
 *
 * To run a query within a React component, call `useGetOrganizationInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationInvitesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationInvitesQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationInvitesQuery, GetOrganizationInvitesQueryVariables> & ({ variables: GetOrganizationInvitesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationInvitesQuery, GetOrganizationInvitesQueryVariables>(GetOrganizationInvitesDocument, options);
      }
export function useGetOrganizationInvitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationInvitesQuery, GetOrganizationInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationInvitesQuery, GetOrganizationInvitesQueryVariables>(GetOrganizationInvitesDocument, options);
        }
// @ts-ignore
export function useGetOrganizationInvitesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationInvitesQuery, GetOrganizationInvitesQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationInvitesQuery, GetOrganizationInvitesQueryVariables>;
export function useGetOrganizationInvitesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationInvitesQuery, GetOrganizationInvitesQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationInvitesQuery | undefined, GetOrganizationInvitesQueryVariables>;
export function useGetOrganizationInvitesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationInvitesQuery, GetOrganizationInvitesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationInvitesQuery, GetOrganizationInvitesQueryVariables>(GetOrganizationInvitesDocument, options);
        }
export type GetOrganizationInvitesQueryHookResult = ReturnType<typeof useGetOrganizationInvitesQuery>;
export type GetOrganizationInvitesLazyQueryHookResult = ReturnType<typeof useGetOrganizationInvitesLazyQuery>;
export type GetOrganizationInvitesSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationInvitesSuspenseQuery>;
export type GetOrganizationInvitesQueryResult = Apollo.QueryResult<GetOrganizationInvitesQuery, GetOrganizationInvitesQueryVariables>;
export const InvitePreviewDocument = gql`
    query InvitePreview($inviteCode: ID!) {
  invitePreview(inviteCode: $inviteCode) {
    inviteCode
    email
    role
    status
    isExpired
    expiresAt
    organization {
      id
      name
    }
    createdByUser {
      id
      displayName
    }
  }
}
    `;

/**
 * __useInvitePreviewQuery__
 *
 * To run a query within a React component, call `useInvitePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitePreviewQuery({
 *   variables: {
 *      inviteCode: // value for 'inviteCode'
 *   },
 * });
 */
export function useInvitePreviewQuery(baseOptions: Apollo.QueryHookOptions<InvitePreviewQuery, InvitePreviewQueryVariables> & ({ variables: InvitePreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvitePreviewQuery, InvitePreviewQueryVariables>(InvitePreviewDocument, options);
      }
export function useInvitePreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvitePreviewQuery, InvitePreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvitePreviewQuery, InvitePreviewQueryVariables>(InvitePreviewDocument, options);
        }
// @ts-ignore
export function useInvitePreviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvitePreviewQuery, InvitePreviewQueryVariables>): Apollo.UseSuspenseQueryResult<InvitePreviewQuery, InvitePreviewQueryVariables>;
export function useInvitePreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvitePreviewQuery, InvitePreviewQueryVariables>): Apollo.UseSuspenseQueryResult<InvitePreviewQuery | undefined, InvitePreviewQueryVariables>;
export function useInvitePreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvitePreviewQuery, InvitePreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvitePreviewQuery, InvitePreviewQueryVariables>(InvitePreviewDocument, options);
        }
export type InvitePreviewQueryHookResult = ReturnType<typeof useInvitePreviewQuery>;
export type InvitePreviewLazyQueryHookResult = ReturnType<typeof useInvitePreviewLazyQuery>;
export type InvitePreviewSuspenseQueryHookResult = ReturnType<typeof useInvitePreviewSuspenseQuery>;
export type InvitePreviewQueryResult = Apollo.QueryResult<InvitePreviewQuery, InvitePreviewQueryVariables>;
export const GetOrganizationMembersDocument = gql`
    query GetOrganizationMembers($id: ID!) {
  organization(id: $id) {
    id
    name
    websiteUrl
    workosId
    createdAt
    updatedAt
    members {
      role
      user {
        id
        displayName
        email
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationMembersQuery__
 *
 * To run a query within a React component, call `useGetOrganizationMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationMembersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganizationMembersQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables> & ({ variables: GetOrganizationMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables>(GetOrganizationMembersDocument, options);
      }
export function useGetOrganizationMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables>(GetOrganizationMembersDocument, options);
        }
// @ts-ignore
export function useGetOrganizationMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables>;
export function useGetOrganizationMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationMembersQuery | undefined, GetOrganizationMembersQueryVariables>;
export function useGetOrganizationMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables>(GetOrganizationMembersDocument, options);
        }
export type GetOrganizationMembersQueryHookResult = ReturnType<typeof useGetOrganizationMembersQuery>;
export type GetOrganizationMembersLazyQueryHookResult = ReturnType<typeof useGetOrganizationMembersLazyQuery>;
export type GetOrganizationMembersSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationMembersSuspenseQuery>;
export type GetOrganizationMembersQueryResult = Apollo.QueryResult<GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables>;
export const MergeNodesDocument = gql`
    mutation MergeNodes($organizationId: ID!, $input: MergeNodesInput!) {
  mergeNodes(organizationId: $organizationId, input: $input) {
    survivingNode {
      id
      displayName
      typeName
    }
    mergedNodeIds
    redirectedEdgeCount
    consolidatedEdgeCount
    deletedEdgeCount
  }
}
    `;
export type MergeNodesMutationFn = Apollo.MutationFunction<MergeNodesMutation, MergeNodesMutationVariables>;

/**
 * __useMergeNodesMutation__
 *
 * To run a mutation, you first call `useMergeNodesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeNodesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeNodesMutation, { data, loading, error }] = useMergeNodesMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMergeNodesMutation(baseOptions?: Apollo.MutationHookOptions<MergeNodesMutation, MergeNodesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeNodesMutation, MergeNodesMutationVariables>(MergeNodesDocument, options);
      }
export type MergeNodesMutationHookResult = ReturnType<typeof useMergeNodesMutation>;
export type MergeNodesMutationResult = Apollo.MutationResult<MergeNodesMutation>;
export type MergeNodesMutationOptions = Apollo.BaseMutationOptions<MergeNodesMutation, MergeNodesMutationVariables>;
export const GetSavaSessionsDocument = gql`
    query GetSavaSessions($organizationId: ID!) {
  savaSessions(organizationId: $organizationId) {
    id
    title
    messageCount
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetSavaSessionsQuery__
 *
 * To run a query within a React component, call `useGetSavaSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavaSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavaSessionsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetSavaSessionsQuery(baseOptions: Apollo.QueryHookOptions<GetSavaSessionsQuery, GetSavaSessionsQueryVariables> & ({ variables: GetSavaSessionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSavaSessionsQuery, GetSavaSessionsQueryVariables>(GetSavaSessionsDocument, options);
      }
export function useGetSavaSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSavaSessionsQuery, GetSavaSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSavaSessionsQuery, GetSavaSessionsQueryVariables>(GetSavaSessionsDocument, options);
        }
// @ts-ignore
export function useGetSavaSessionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSavaSessionsQuery, GetSavaSessionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSavaSessionsQuery, GetSavaSessionsQueryVariables>;
export function useGetSavaSessionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSavaSessionsQuery, GetSavaSessionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSavaSessionsQuery | undefined, GetSavaSessionsQueryVariables>;
export function useGetSavaSessionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSavaSessionsQuery, GetSavaSessionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSavaSessionsQuery, GetSavaSessionsQueryVariables>(GetSavaSessionsDocument, options);
        }
export type GetSavaSessionsQueryHookResult = ReturnType<typeof useGetSavaSessionsQuery>;
export type GetSavaSessionsLazyQueryHookResult = ReturnType<typeof useGetSavaSessionsLazyQuery>;
export type GetSavaSessionsSuspenseQueryHookResult = ReturnType<typeof useGetSavaSessionsSuspenseQuery>;
export type GetSavaSessionsQueryResult = Apollo.QueryResult<GetSavaSessionsQuery, GetSavaSessionsQueryVariables>;
export const GetSavaSessionDocument = gql`
    query GetSavaSession($organizationId: ID!, $sessionId: ID!) {
  savaSession(organizationId: $organizationId, sessionId: $sessionId) {
    id
    title
    createdAt
    updatedAt
    messages {
      id
      role
      content
      suggestions
      confidence
      toolsUsed
      createdAt
    }
  }
}
    `;

/**
 * __useGetSavaSessionQuery__
 *
 * To run a query within a React component, call `useGetSavaSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavaSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavaSessionQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useGetSavaSessionQuery(baseOptions: Apollo.QueryHookOptions<GetSavaSessionQuery, GetSavaSessionQueryVariables> & ({ variables: GetSavaSessionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSavaSessionQuery, GetSavaSessionQueryVariables>(GetSavaSessionDocument, options);
      }
export function useGetSavaSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSavaSessionQuery, GetSavaSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSavaSessionQuery, GetSavaSessionQueryVariables>(GetSavaSessionDocument, options);
        }
// @ts-ignore
export function useGetSavaSessionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSavaSessionQuery, GetSavaSessionQueryVariables>): Apollo.UseSuspenseQueryResult<GetSavaSessionQuery, GetSavaSessionQueryVariables>;
export function useGetSavaSessionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSavaSessionQuery, GetSavaSessionQueryVariables>): Apollo.UseSuspenseQueryResult<GetSavaSessionQuery | undefined, GetSavaSessionQueryVariables>;
export function useGetSavaSessionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSavaSessionQuery, GetSavaSessionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSavaSessionQuery, GetSavaSessionQueryVariables>(GetSavaSessionDocument, options);
        }
export type GetSavaSessionQueryHookResult = ReturnType<typeof useGetSavaSessionQuery>;
export type GetSavaSessionLazyQueryHookResult = ReturnType<typeof useGetSavaSessionLazyQuery>;
export type GetSavaSessionSuspenseQueryHookResult = ReturnType<typeof useGetSavaSessionSuspenseQuery>;
export type GetSavaSessionQueryResult = Apollo.QueryResult<GetSavaSessionQuery, GetSavaSessionQueryVariables>;
export const DeleteSavaSessionDocument = gql`
    mutation DeleteSavaSession($organizationId: ID!, $sessionId: ID!) {
  deleteSavaSession(organizationId: $organizationId, sessionId: $sessionId)
}
    `;
export type DeleteSavaSessionMutationFn = Apollo.MutationFunction<DeleteSavaSessionMutation, DeleteSavaSessionMutationVariables>;

/**
 * __useDeleteSavaSessionMutation__
 *
 * To run a mutation, you first call `useDeleteSavaSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSavaSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSavaSessionMutation, { data, loading, error }] = useDeleteSavaSessionMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useDeleteSavaSessionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSavaSessionMutation, DeleteSavaSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSavaSessionMutation, DeleteSavaSessionMutationVariables>(DeleteSavaSessionDocument, options);
      }
export type DeleteSavaSessionMutationHookResult = ReturnType<typeof useDeleteSavaSessionMutation>;
export type DeleteSavaSessionMutationResult = Apollo.MutationResult<DeleteSavaSessionMutation>;
export type DeleteSavaSessionMutationOptions = Apollo.BaseMutationOptions<DeleteSavaSessionMutation, DeleteSavaSessionMutationVariables>;
export const FindDuplicatesDocument = gql`
    query FindDuplicates($organizationId: ID!, $limit: Int, $minConfidence: Float) {
  findDuplicates(
    organizationId: $organizationId
    limit: $limit
    minConfidence: $minConfidence
  ) {
    groups {
      id
      nodes {
        id
        displayName
        typeName
        properties
      }
      confidence
      pairs {
        nodeA
        nodeB
        score
        signals {
          type
          detail
          score
        }
      }
    }
    totalGroupsFound
    analyzedNodeCount
  }
}
    `;

/**
 * __useFindDuplicatesQuery__
 *
 * To run a query within a React component, call `useFindDuplicatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindDuplicatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindDuplicatesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      limit: // value for 'limit'
 *      minConfidence: // value for 'minConfidence'
 *   },
 * });
 */
export function useFindDuplicatesQuery(baseOptions: Apollo.QueryHookOptions<FindDuplicatesQuery, FindDuplicatesQueryVariables> & ({ variables: FindDuplicatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindDuplicatesQuery, FindDuplicatesQueryVariables>(FindDuplicatesDocument, options);
      }
export function useFindDuplicatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindDuplicatesQuery, FindDuplicatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindDuplicatesQuery, FindDuplicatesQueryVariables>(FindDuplicatesDocument, options);
        }
// @ts-ignore
export function useFindDuplicatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindDuplicatesQuery, FindDuplicatesQueryVariables>): Apollo.UseSuspenseQueryResult<FindDuplicatesQuery, FindDuplicatesQueryVariables>;
export function useFindDuplicatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindDuplicatesQuery, FindDuplicatesQueryVariables>): Apollo.UseSuspenseQueryResult<FindDuplicatesQuery | undefined, FindDuplicatesQueryVariables>;
export function useFindDuplicatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindDuplicatesQuery, FindDuplicatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindDuplicatesQuery, FindDuplicatesQueryVariables>(FindDuplicatesDocument, options);
        }
export type FindDuplicatesQueryHookResult = ReturnType<typeof useFindDuplicatesQuery>;
export type FindDuplicatesLazyQueryHookResult = ReturnType<typeof useFindDuplicatesLazyQuery>;
export type FindDuplicatesSuspenseQueryHookResult = ReturnType<typeof useFindDuplicatesSuspenseQuery>;
export type FindDuplicatesQueryResult = Apollo.QueryResult<FindDuplicatesQuery, FindDuplicatesQueryVariables>;
export const PermissionRulesDocument = gql`
    query PermissionRules($organizationId: ID!) {
  permissionRules(organizationId: $organizationId) {
    id
    name
    subjectKind
    subjectId
    level
    priority
    source
    locked
    description
    scope {
      kind
      nodeId
      nodeType
      tag
      name
      propId
      propName
      edgeId
      predicate
    }
  }
}
    `;

/**
 * __usePermissionRulesQuery__
 *
 * To run a query within a React component, call `usePermissionRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionRulesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function usePermissionRulesQuery(baseOptions: Apollo.QueryHookOptions<PermissionRulesQuery, PermissionRulesQueryVariables> & ({ variables: PermissionRulesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PermissionRulesQuery, PermissionRulesQueryVariables>(PermissionRulesDocument, options);
      }
export function usePermissionRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PermissionRulesQuery, PermissionRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PermissionRulesQuery, PermissionRulesQueryVariables>(PermissionRulesDocument, options);
        }
// @ts-ignore
export function usePermissionRulesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PermissionRulesQuery, PermissionRulesQueryVariables>): Apollo.UseSuspenseQueryResult<PermissionRulesQuery, PermissionRulesQueryVariables>;
export function usePermissionRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PermissionRulesQuery, PermissionRulesQueryVariables>): Apollo.UseSuspenseQueryResult<PermissionRulesQuery | undefined, PermissionRulesQueryVariables>;
export function usePermissionRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PermissionRulesQuery, PermissionRulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PermissionRulesQuery, PermissionRulesQueryVariables>(PermissionRulesDocument, options);
        }
export type PermissionRulesQueryHookResult = ReturnType<typeof usePermissionRulesQuery>;
export type PermissionRulesLazyQueryHookResult = ReturnType<typeof usePermissionRulesLazyQuery>;
export type PermissionRulesSuspenseQueryHookResult = ReturnType<typeof usePermissionRulesSuspenseQuery>;
export type PermissionRulesQueryResult = Apollo.QueryResult<PermissionRulesQuery, PermissionRulesQueryVariables>;
export const PermissionSubjectsDocument = gql`
    query PermissionSubjects($organizationId: ID!) {
  permissionSubjects(organizationId: $organizationId) {
    users {
      id
      name
      roleId
      teamIds
      isAdmin
    }
    teams {
      id
      name
      color
      memberIds
    }
    roles {
      id
      name
      description
      color
      isSystem
    }
  }
}
    `;

/**
 * __usePermissionSubjectsQuery__
 *
 * To run a query within a React component, call `usePermissionSubjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionSubjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionSubjectsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function usePermissionSubjectsQuery(baseOptions: Apollo.QueryHookOptions<PermissionSubjectsQuery, PermissionSubjectsQueryVariables> & ({ variables: PermissionSubjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PermissionSubjectsQuery, PermissionSubjectsQueryVariables>(PermissionSubjectsDocument, options);
      }
export function usePermissionSubjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PermissionSubjectsQuery, PermissionSubjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PermissionSubjectsQuery, PermissionSubjectsQueryVariables>(PermissionSubjectsDocument, options);
        }
// @ts-ignore
export function usePermissionSubjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PermissionSubjectsQuery, PermissionSubjectsQueryVariables>): Apollo.UseSuspenseQueryResult<PermissionSubjectsQuery, PermissionSubjectsQueryVariables>;
export function usePermissionSubjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PermissionSubjectsQuery, PermissionSubjectsQueryVariables>): Apollo.UseSuspenseQueryResult<PermissionSubjectsQuery | undefined, PermissionSubjectsQueryVariables>;
export function usePermissionSubjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PermissionSubjectsQuery, PermissionSubjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PermissionSubjectsQuery, PermissionSubjectsQueryVariables>(PermissionSubjectsDocument, options);
        }
export type PermissionSubjectsQueryHookResult = ReturnType<typeof usePermissionSubjectsQuery>;
export type PermissionSubjectsLazyQueryHookResult = ReturnType<typeof usePermissionSubjectsLazyQuery>;
export type PermissionSubjectsSuspenseQueryHookResult = ReturnType<typeof usePermissionSubjectsSuspenseQuery>;
export type PermissionSubjectsQueryResult = Apollo.QueryResult<PermissionSubjectsQuery, PermissionSubjectsQueryVariables>;
export const EffectiveNodeAccessDocument = gql`
    query EffectiveNodeAccess($organizationId: ID!, $nodeId: ID!, $subject: PreviewSubjectInput) {
  effectiveNodeAccess(
    organizationId: $organizationId
    nodeId: $nodeId
    subject: $subject
  ) {
    nodeId
    level
    properties {
      key
      access
    }
    edges {
      edgeId
      access
      properties {
        key
        access
      }
    }
  }
}
    `;

/**
 * __useEffectiveNodeAccessQuery__
 *
 * To run a query within a React component, call `useEffectiveNodeAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useEffectiveNodeAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEffectiveNodeAccessQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      nodeId: // value for 'nodeId'
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useEffectiveNodeAccessQuery(baseOptions: Apollo.QueryHookOptions<EffectiveNodeAccessQuery, EffectiveNodeAccessQueryVariables> & ({ variables: EffectiveNodeAccessQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EffectiveNodeAccessQuery, EffectiveNodeAccessQueryVariables>(EffectiveNodeAccessDocument, options);
      }
export function useEffectiveNodeAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EffectiveNodeAccessQuery, EffectiveNodeAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EffectiveNodeAccessQuery, EffectiveNodeAccessQueryVariables>(EffectiveNodeAccessDocument, options);
        }
// @ts-ignore
export function useEffectiveNodeAccessSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EffectiveNodeAccessQuery, EffectiveNodeAccessQueryVariables>): Apollo.UseSuspenseQueryResult<EffectiveNodeAccessQuery, EffectiveNodeAccessQueryVariables>;
export function useEffectiveNodeAccessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EffectiveNodeAccessQuery, EffectiveNodeAccessQueryVariables>): Apollo.UseSuspenseQueryResult<EffectiveNodeAccessQuery | undefined, EffectiveNodeAccessQueryVariables>;
export function useEffectiveNodeAccessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EffectiveNodeAccessQuery, EffectiveNodeAccessQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EffectiveNodeAccessQuery, EffectiveNodeAccessQueryVariables>(EffectiveNodeAccessDocument, options);
        }
export type EffectiveNodeAccessQueryHookResult = ReturnType<typeof useEffectiveNodeAccessQuery>;
export type EffectiveNodeAccessLazyQueryHookResult = ReturnType<typeof useEffectiveNodeAccessLazyQuery>;
export type EffectiveNodeAccessSuspenseQueryHookResult = ReturnType<typeof useEffectiveNodeAccessSuspenseQuery>;
export type EffectiveNodeAccessQueryResult = Apollo.QueryResult<EffectiveNodeAccessQuery, EffectiveNodeAccessQueryVariables>;
export const CreatePermissionRuleDocument = gql`
    mutation CreatePermissionRule($organizationId: ID!, $input: CreatePermissionRuleInput!) {
  createPermissionRule(organizationId: $organizationId, input: $input) {
    id
    name
    subjectKind
    subjectId
    level
    priority
    source
    locked
    description
    scope {
      kind
      nodeId
      nodeType
      tag
      name
      propId
      propName
      edgeId
      predicate
    }
  }
}
    `;
export type CreatePermissionRuleMutationFn = Apollo.MutationFunction<CreatePermissionRuleMutation, CreatePermissionRuleMutationVariables>;

/**
 * __useCreatePermissionRuleMutation__
 *
 * To run a mutation, you first call `useCreatePermissionRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePermissionRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPermissionRuleMutation, { data, loading, error }] = useCreatePermissionRuleMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePermissionRuleMutation(baseOptions?: Apollo.MutationHookOptions<CreatePermissionRuleMutation, CreatePermissionRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePermissionRuleMutation, CreatePermissionRuleMutationVariables>(CreatePermissionRuleDocument, options);
      }
export type CreatePermissionRuleMutationHookResult = ReturnType<typeof useCreatePermissionRuleMutation>;
export type CreatePermissionRuleMutationResult = Apollo.MutationResult<CreatePermissionRuleMutation>;
export type CreatePermissionRuleMutationOptions = Apollo.BaseMutationOptions<CreatePermissionRuleMutation, CreatePermissionRuleMutationVariables>;
export const UpdatePermissionRuleDocument = gql`
    mutation UpdatePermissionRule($organizationId: ID!, $id: ID!, $input: UpdatePermissionRuleInput!) {
  updatePermissionRule(organizationId: $organizationId, id: $id, input: $input) {
    id
    name
    subjectKind
    subjectId
    level
    priority
    source
    locked
    description
    scope {
      kind
      nodeId
      nodeType
      tag
      name
      propId
      propName
      edgeId
      predicate
    }
  }
}
    `;
export type UpdatePermissionRuleMutationFn = Apollo.MutationFunction<UpdatePermissionRuleMutation, UpdatePermissionRuleMutationVariables>;

/**
 * __useUpdatePermissionRuleMutation__
 *
 * To run a mutation, you first call `useUpdatePermissionRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePermissionRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePermissionRuleMutation, { data, loading, error }] = useUpdatePermissionRuleMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePermissionRuleMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePermissionRuleMutation, UpdatePermissionRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePermissionRuleMutation, UpdatePermissionRuleMutationVariables>(UpdatePermissionRuleDocument, options);
      }
export type UpdatePermissionRuleMutationHookResult = ReturnType<typeof useUpdatePermissionRuleMutation>;
export type UpdatePermissionRuleMutationResult = Apollo.MutationResult<UpdatePermissionRuleMutation>;
export type UpdatePermissionRuleMutationOptions = Apollo.BaseMutationOptions<UpdatePermissionRuleMutation, UpdatePermissionRuleMutationVariables>;
export const DeletePermissionRuleDocument = gql`
    mutation DeletePermissionRule($organizationId: ID!, $id: ID!) {
  deletePermissionRule(organizationId: $organizationId, id: $id)
}
    `;
export type DeletePermissionRuleMutationFn = Apollo.MutationFunction<DeletePermissionRuleMutation, DeletePermissionRuleMutationVariables>;

/**
 * __useDeletePermissionRuleMutation__
 *
 * To run a mutation, you first call `useDeletePermissionRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePermissionRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePermissionRuleMutation, { data, loading, error }] = useDeletePermissionRuleMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePermissionRuleMutation(baseOptions?: Apollo.MutationHookOptions<DeletePermissionRuleMutation, DeletePermissionRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePermissionRuleMutation, DeletePermissionRuleMutationVariables>(DeletePermissionRuleDocument, options);
      }
export type DeletePermissionRuleMutationHookResult = ReturnType<typeof useDeletePermissionRuleMutation>;
export type DeletePermissionRuleMutationResult = Apollo.MutationResult<DeletePermissionRuleMutation>;
export type DeletePermissionRuleMutationOptions = Apollo.BaseMutationOptions<DeletePermissionRuleMutation, DeletePermissionRuleMutationVariables>;
export const CreateTeamDocument = gql`
    mutation CreateTeam($organizationId: ID!, $name: String!, $color: String) {
  createTeam(organizationId: $organizationId, name: $name, color: $color) {
    id
    name
    color
  }
}
    `;
export type CreateTeamMutationFn = Apollo.MutationFunction<CreateTeamMutation, CreateTeamMutationVariables>;

/**
 * __useCreateTeamMutation__
 *
 * To run a mutation, you first call `useCreateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMutation, { data, loading, error }] = useCreateTeamMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      name: // value for 'name'
 *      color: // value for 'color'
 *   },
 * });
 */
export function useCreateTeamMutation(baseOptions?: Apollo.MutationHookOptions<CreateTeamMutation, CreateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTeamMutation, CreateTeamMutationVariables>(CreateTeamDocument, options);
      }
export type CreateTeamMutationHookResult = ReturnType<typeof useCreateTeamMutation>;
export type CreateTeamMutationResult = Apollo.MutationResult<CreateTeamMutation>;
export type CreateTeamMutationOptions = Apollo.BaseMutationOptions<CreateTeamMutation, CreateTeamMutationVariables>;
export const AddTeamMemberDocument = gql`
    mutation AddTeamMember($organizationId: ID!, $teamId: ID!, $userId: ID!) {
  addTeamMember(organizationId: $organizationId, teamId: $teamId, userId: $userId)
}
    `;
export type AddTeamMemberMutationFn = Apollo.MutationFunction<AddTeamMemberMutation, AddTeamMemberMutationVariables>;

/**
 * __useAddTeamMemberMutation__
 *
 * To run a mutation, you first call `useAddTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTeamMemberMutation, { data, loading, error }] = useAddTeamMemberMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      teamId: // value for 'teamId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAddTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<AddTeamMemberMutation, AddTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTeamMemberMutation, AddTeamMemberMutationVariables>(AddTeamMemberDocument, options);
      }
export type AddTeamMemberMutationHookResult = ReturnType<typeof useAddTeamMemberMutation>;
export type AddTeamMemberMutationResult = Apollo.MutationResult<AddTeamMemberMutation>;
export type AddTeamMemberMutationOptions = Apollo.BaseMutationOptions<AddTeamMemberMutation, AddTeamMemberMutationVariables>;
export const RemoveTeamMemberDocument = gql`
    mutation RemoveTeamMember($organizationId: ID!, $teamId: ID!, $userId: ID!) {
  removeTeamMember(
    organizationId: $organizationId
    teamId: $teamId
    userId: $userId
  )
}
    `;
export type RemoveTeamMemberMutationFn = Apollo.MutationFunction<RemoveTeamMemberMutation, RemoveTeamMemberMutationVariables>;

/**
 * __useRemoveTeamMemberMutation__
 *
 * To run a mutation, you first call `useRemoveTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTeamMemberMutation, { data, loading, error }] = useRemoveTeamMemberMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      teamId: // value for 'teamId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTeamMemberMutation, RemoveTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTeamMemberMutation, RemoveTeamMemberMutationVariables>(RemoveTeamMemberDocument, options);
      }
export type RemoveTeamMemberMutationHookResult = ReturnType<typeof useRemoveTeamMemberMutation>;
export type RemoveTeamMemberMutationResult = Apollo.MutationResult<RemoveTeamMemberMutation>;
export type RemoveTeamMemberMutationOptions = Apollo.BaseMutationOptions<RemoveTeamMemberMutation, RemoveTeamMemberMutationVariables>;
export const CreateRoleDocument = gql`
    mutation CreateRole($organizationId: ID!, $name: String!, $description: String, $color: String) {
  createRole(
    organizationId: $organizationId
    name: $name
    description: $description
    color: $color
  ) {
    id
    name
    description
    color
    isSystem
  }
}
    `;
export type CreateRoleMutationFn = Apollo.MutationFunction<CreateRoleMutation, CreateRoleMutationVariables>;

/**
 * __useCreateRoleMutation__
 *
 * To run a mutation, you first call `useCreateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoleMutation, { data, loading, error }] = useCreateRoleMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      color: // value for 'color'
 *   },
 * });
 */
export function useCreateRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoleMutation, CreateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRoleMutation, CreateRoleMutationVariables>(CreateRoleDocument, options);
      }
export type CreateRoleMutationHookResult = ReturnType<typeof useCreateRoleMutation>;
export type CreateRoleMutationResult = Apollo.MutationResult<CreateRoleMutation>;
export type CreateRoleMutationOptions = Apollo.BaseMutationOptions<CreateRoleMutation, CreateRoleMutationVariables>;
export const AssignRoleDocument = gql`
    mutation AssignRole($organizationId: ID!, $userId: ID!, $roleId: ID) {
  assignRole(organizationId: $organizationId, userId: $userId, roleId: $roleId)
}
    `;
export type AssignRoleMutationFn = Apollo.MutationFunction<AssignRoleMutation, AssignRoleMutationVariables>;

/**
 * __useAssignRoleMutation__
 *
 * To run a mutation, you first call `useAssignRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignRoleMutation, { data, loading, error }] = useAssignRoleMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useAssignRoleMutation(baseOptions?: Apollo.MutationHookOptions<AssignRoleMutation, AssignRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignRoleMutation, AssignRoleMutationVariables>(AssignRoleDocument, options);
      }
export type AssignRoleMutationHookResult = ReturnType<typeof useAssignRoleMutation>;
export type AssignRoleMutationResult = Apollo.MutationResult<AssignRoleMutation>;
export type AssignRoleMutationOptions = Apollo.BaseMutationOptions<AssignRoleMutation, AssignRoleMutationVariables>;
export const GetEdgeDetailDocument = gql`
    query GetEdgeDetail($organizationId: ID!, $edgeId: ID!, $first: Int = 20, $after: String) {
  edge(organizationId: $organizationId, id: $edgeId) {
    id
    organizationId
    sourceNode
    targetNode
    strength
    primaryNature
    publicSummary
    publicSummaryGeneratedAt
    lastEventAt
    eventCount
    source {
      id
      displayName
      typeName
    }
    target {
      id
      displayName
      typeName
    }
    topOfMindEvents {
      id
      eventType
      occurredAt
      createdAt
      source
      payload
      participations {
        role
        node {
          id
          displayName
        }
      }
    }
    events(first: $first, after: $after) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        cursor
        node {
          id
          eventType
          occurredAt
          createdAt
          source
          payload
          participations {
            role
            node {
              id
              displayName
            }
          }
        }
      }
    }
    privateContext {
      privateSummary
      generatedAt
      topOfMindEvents {
        id
        eventType
        occurredAt
        createdAt
        source
        payload
        participations {
          role
          node {
            id
            displayName
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetEdgeDetailQuery__
 *
 * To run a query within a React component, call `useGetEdgeDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEdgeDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEdgeDetailQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      edgeId: // value for 'edgeId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetEdgeDetailQuery(baseOptions: Apollo.QueryHookOptions<GetEdgeDetailQuery, GetEdgeDetailQueryVariables> & ({ variables: GetEdgeDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEdgeDetailQuery, GetEdgeDetailQueryVariables>(GetEdgeDetailDocument, options);
      }
export function useGetEdgeDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEdgeDetailQuery, GetEdgeDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEdgeDetailQuery, GetEdgeDetailQueryVariables>(GetEdgeDetailDocument, options);
        }
// @ts-ignore
export function useGetEdgeDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEdgeDetailQuery, GetEdgeDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetEdgeDetailQuery, GetEdgeDetailQueryVariables>;
export function useGetEdgeDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEdgeDetailQuery, GetEdgeDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetEdgeDetailQuery | undefined, GetEdgeDetailQueryVariables>;
export function useGetEdgeDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEdgeDetailQuery, GetEdgeDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEdgeDetailQuery, GetEdgeDetailQueryVariables>(GetEdgeDetailDocument, options);
        }
export type GetEdgeDetailQueryHookResult = ReturnType<typeof useGetEdgeDetailQuery>;
export type GetEdgeDetailLazyQueryHookResult = ReturnType<typeof useGetEdgeDetailLazyQuery>;
export type GetEdgeDetailSuspenseQueryHookResult = ReturnType<typeof useGetEdgeDetailSuspenseQuery>;
export type GetEdgeDetailQueryResult = Apollo.QueryResult<GetEdgeDetailQuery, GetEdgeDetailQueryVariables>;
export const GetEdgeSummaryStatusDocument = gql`
    query GetEdgeSummaryStatus($organizationId: ID!, $edgeId: ID!) {
  edge(organizationId: $organizationId, id: $edgeId) {
    id
    strength
    primaryNature
    publicSummary
    publicSummaryGeneratedAt
    lastEventAt
    eventCount
  }
}
    `;

/**
 * __useGetEdgeSummaryStatusQuery__
 *
 * To run a query within a React component, call `useGetEdgeSummaryStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEdgeSummaryStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEdgeSummaryStatusQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      edgeId: // value for 'edgeId'
 *   },
 * });
 */
export function useGetEdgeSummaryStatusQuery(baseOptions: Apollo.QueryHookOptions<GetEdgeSummaryStatusQuery, GetEdgeSummaryStatusQueryVariables> & ({ variables: GetEdgeSummaryStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEdgeSummaryStatusQuery, GetEdgeSummaryStatusQueryVariables>(GetEdgeSummaryStatusDocument, options);
      }
export function useGetEdgeSummaryStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEdgeSummaryStatusQuery, GetEdgeSummaryStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEdgeSummaryStatusQuery, GetEdgeSummaryStatusQueryVariables>(GetEdgeSummaryStatusDocument, options);
        }
// @ts-ignore
export function useGetEdgeSummaryStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEdgeSummaryStatusQuery, GetEdgeSummaryStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetEdgeSummaryStatusQuery, GetEdgeSummaryStatusQueryVariables>;
export function useGetEdgeSummaryStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEdgeSummaryStatusQuery, GetEdgeSummaryStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetEdgeSummaryStatusQuery | undefined, GetEdgeSummaryStatusQueryVariables>;
export function useGetEdgeSummaryStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEdgeSummaryStatusQuery, GetEdgeSummaryStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEdgeSummaryStatusQuery, GetEdgeSummaryStatusQueryVariables>(GetEdgeSummaryStatusDocument, options);
        }
export type GetEdgeSummaryStatusQueryHookResult = ReturnType<typeof useGetEdgeSummaryStatusQuery>;
export type GetEdgeSummaryStatusLazyQueryHookResult = ReturnType<typeof useGetEdgeSummaryStatusLazyQuery>;
export type GetEdgeSummaryStatusSuspenseQueryHookResult = ReturnType<typeof useGetEdgeSummaryStatusSuspenseQuery>;
export type GetEdgeSummaryStatusQueryResult = Apollo.QueryResult<GetEdgeSummaryStatusQuery, GetEdgeSummaryStatusQueryVariables>;
export const GetNodeConnectionsDocument = gql`
    query GetNodeConnections($organizationId: ID!, $nodeId: ID!) {
  node(organizationId: $organizationId, id: $nodeId) {
    id
    edges {
      id
      publicSummary
    }
  }
}
    `;

/**
 * __useGetNodeConnectionsQuery__
 *
 * To run a query within a React component, call `useGetNodeConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNodeConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNodeConnectionsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useGetNodeConnectionsQuery(baseOptions: Apollo.QueryHookOptions<GetNodeConnectionsQuery, GetNodeConnectionsQueryVariables> & ({ variables: GetNodeConnectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNodeConnectionsQuery, GetNodeConnectionsQueryVariables>(GetNodeConnectionsDocument, options);
      }
export function useGetNodeConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNodeConnectionsQuery, GetNodeConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNodeConnectionsQuery, GetNodeConnectionsQueryVariables>(GetNodeConnectionsDocument, options);
        }
// @ts-ignore
export function useGetNodeConnectionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNodeConnectionsQuery, GetNodeConnectionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetNodeConnectionsQuery, GetNodeConnectionsQueryVariables>;
export function useGetNodeConnectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNodeConnectionsQuery, GetNodeConnectionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetNodeConnectionsQuery | undefined, GetNodeConnectionsQueryVariables>;
export function useGetNodeConnectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNodeConnectionsQuery, GetNodeConnectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNodeConnectionsQuery, GetNodeConnectionsQueryVariables>(GetNodeConnectionsDocument, options);
        }
export type GetNodeConnectionsQueryHookResult = ReturnType<typeof useGetNodeConnectionsQuery>;
export type GetNodeConnectionsLazyQueryHookResult = ReturnType<typeof useGetNodeConnectionsLazyQuery>;
export type GetNodeConnectionsSuspenseQueryHookResult = ReturnType<typeof useGetNodeConnectionsSuspenseQuery>;
export type GetNodeConnectionsQueryResult = Apollo.QueryResult<GetNodeConnectionsQuery, GetNodeConnectionsQueryVariables>;
export const GetEventsDocument = gql`
    query GetEvents($organizationId: ID!, $ids: [ID!]!) {
  events(organizationId: $organizationId, ids: $ids) {
    id
    eventType
    occurredAt
    createdAt
    source
    payload
    participations {
      role
      node {
        id
        displayName
      }
    }
  }
}
    `;

/**
 * __useGetEventsQuery__
 *
 * To run a query within a React component, call `useGetEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetEventsQuery(baseOptions: Apollo.QueryHookOptions<GetEventsQuery, GetEventsQueryVariables> & ({ variables: GetEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventsQuery, GetEventsQueryVariables>(GetEventsDocument, options);
      }
export function useGetEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventsQuery, GetEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventsQuery, GetEventsQueryVariables>(GetEventsDocument, options);
        }
// @ts-ignore
export function useGetEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventsQuery, GetEventsQueryVariables>): Apollo.UseSuspenseQueryResult<GetEventsQuery, GetEventsQueryVariables>;
export function useGetEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventsQuery, GetEventsQueryVariables>): Apollo.UseSuspenseQueryResult<GetEventsQuery | undefined, GetEventsQueryVariables>;
export function useGetEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventsQuery, GetEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventsQuery, GetEventsQueryVariables>(GetEventsDocument, options);
        }
export type GetEventsQueryHookResult = ReturnType<typeof useGetEventsQuery>;
export type GetEventsLazyQueryHookResult = ReturnType<typeof useGetEventsLazyQuery>;
export type GetEventsSuspenseQueryHookResult = ReturnType<typeof useGetEventsSuspenseQuery>;
export type GetEventsQueryResult = Apollo.QueryResult<GetEventsQuery, GetEventsQueryVariables>;
export const CreateManualNoteEventDocument = gql`
    mutation CreateManualNoteEvent($organizationId: ID!, $input: CreateManualNoteEventInput!) {
  createManualNoteEvent(organizationId: $organizationId, input: $input) {
    event {
      id
      eventType
      occurredAt
      createdAt
      source
      payload
      participations {
        role
        node {
          id
          displayName
        }
      }
    }
    affectedEdges {
      id
      strength
      primaryNature
      publicSummary
      publicSummaryGeneratedAt
      lastEventAt
      eventCount
    }
  }
}
    `;
export type CreateManualNoteEventMutationFn = Apollo.MutationFunction<CreateManualNoteEventMutation, CreateManualNoteEventMutationVariables>;

/**
 * __useCreateManualNoteEventMutation__
 *
 * To run a mutation, you first call `useCreateManualNoteEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManualNoteEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManualNoteEventMutation, { data, loading, error }] = useCreateManualNoteEventMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateManualNoteEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateManualNoteEventMutation, CreateManualNoteEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateManualNoteEventMutation, CreateManualNoteEventMutationVariables>(CreateManualNoteEventDocument, options);
      }
export type CreateManualNoteEventMutationHookResult = ReturnType<typeof useCreateManualNoteEventMutation>;
export type CreateManualNoteEventMutationResult = Apollo.MutationResult<CreateManualNoteEventMutation>;
export type CreateManualNoteEventMutationOptions = Apollo.BaseMutationOptions<CreateManualNoteEventMutation, CreateManualNoteEventMutationVariables>;
export const RefreshEdgeSummaryDocument = gql`
    mutation RefreshEdgeSummary($organizationId: ID!, $edgeId: ID!) {
  refreshEdgeSummary(organizationId: $organizationId, edgeId: $edgeId) {
    id
    strength
    primaryNature
    publicSummary
    publicSummaryGeneratedAt
    lastEventAt
    eventCount
    topOfMindEvents {
      id
      eventType
      occurredAt
      createdAt
      source
      payload
      participations {
        role
        node {
          id
          displayName
        }
      }
    }
    privateContext {
      privateSummary
      generatedAt
      topOfMindEvents {
        id
        eventType
        occurredAt
        createdAt
        source
        payload
        participations {
          role
          node {
            id
            displayName
          }
        }
      }
    }
  }
}
    `;
export type RefreshEdgeSummaryMutationFn = Apollo.MutationFunction<RefreshEdgeSummaryMutation, RefreshEdgeSummaryMutationVariables>;

/**
 * __useRefreshEdgeSummaryMutation__
 *
 * To run a mutation, you first call `useRefreshEdgeSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshEdgeSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshEdgeSummaryMutation, { data, loading, error }] = useRefreshEdgeSummaryMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      edgeId: // value for 'edgeId'
 *   },
 * });
 */
export function useRefreshEdgeSummaryMutation(baseOptions?: Apollo.MutationHookOptions<RefreshEdgeSummaryMutation, RefreshEdgeSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshEdgeSummaryMutation, RefreshEdgeSummaryMutationVariables>(RefreshEdgeSummaryDocument, options);
      }
export type RefreshEdgeSummaryMutationHookResult = ReturnType<typeof useRefreshEdgeSummaryMutation>;
export type RefreshEdgeSummaryMutationResult = Apollo.MutationResult<RefreshEdgeSummaryMutation>;
export type RefreshEdgeSummaryMutationOptions = Apollo.BaseMutationOptions<RefreshEdgeSummaryMutation, RefreshEdgeSummaryMutationVariables>;